const it: Record<string, string> = {
  'nav.overview': 'Panoramica',
  'nav.bookings': 'Le mie prenotazioni',
  'nav.favorites': 'Aziende preferite',
  'nav.home': 'Home',
  'nav.dashboard': 'Dashboard',
  'nav.tracker': 'Tracker',
  'nav.profile': 'Profilo',
  'nav.sign_in': 'Accedi',
  'nav.join_company': 'Diventa azienda',
  'nav.notifications': 'Notifiche',
  'nav.mark_all_read': 'Segna tutte come lette',
  'nav.open': 'Apri',
  'nav.delete': 'Elimina',
  'nav.customer': 'Cliente',
  'nav.company': 'Azienda',
  'nav.sign_out': 'Esci',
  'brand.name': 'Halomora',
  'dash.welcome': 'Bentornato!',
  'dash.subtitle': 'Monitora le prenotazioni e gestisci il tuo account',
  'dash.range.1m': '1 mese',
  'dash.range.3m': '3 mesi',
  'dash.range.6m': '6 mesi',
  'dash.range.1y': '1 anno',
  'dash.spending_trend': 'Andamento spese mensili',
  'dash.service_breakdown': 'Ripartizione per categoria di servizio',
  'dash.service_breakdown.empty': 'Nessun dato disponibile per il periodo selezionato',
  'dash.recent_history': 'Storico servizi recenti',
  'dash.favorite_companies': 'Le tue aziende preferite',
  'booking.step.schedule': "Scegli la data e l'orario",
  'booking.step.details': 'Dettagli & preferenze del servizio',
  'booking.step.info': 'Le tue informazioni',
  'booking.step.review': 'Riepilogo & conferma',
  'booking.btn.next': 'Prossimo passo',
  'booking.btn.prev': 'Indietro',
  'booking.btn.confirm': 'Conferma prenotazione',
  'booking.service_type': 'Tipologia di servizio',
  'booking.property_size': 'Dimensione immobile',
  'booking.urgency': 'Livello di urgenza',
  'booking.special_instructions': 'Istruzioni speciali',
  'booking.upload_photos': 'Carica foto (opzionale)',
  'booking.request_quote': 'Non trovi ciò che ti serve? Richiedi un preventivo',
  'booking.summary': 'Riepilogo prenotazione',
  'profile.title': 'Il mio profilo',
  'profile.tab.bookings': 'Prenotazioni',
  'profile.tab.personal': 'Personale',
  'profile.tab.addresses': 'Indirizzi',
  'profile.tab.payments': 'Pagamenti',
  'profile.tab.notifications': 'Comunicazioni',
  'profile.tab.loyalty': 'Vantaggi',
  'profile.tab.security': 'Sicurezza',
  'profile.tab.quotes': 'Preventivi',
  'vendor.tabs.bookings': 'Prenotazioni recenti',
  'vendor.tabs.calendar': 'Vista calendario',
  'vendor.tabs.tracker': 'Tracker booking',
  'vendor.tracker.no_company': 'Profilo azienda non disponibile.',
  'vendor.tabs.quotes': 'Richieste di preventivo',
  'vendor.tabs.services': 'Gestione servizi',
  'vendor.tabs.pricing': 'Prezzi intelligenti',
  'vendor.tabs.analytics': 'Analisi',
  'vendor.google.title': 'Collega Google Calendar',
  'vendor.google.desc': 'Mantieni le prenotazioni sincronizzate con Google Calendar. Collega il tuo account in pochi secondi.',
  'vendor.google.connect': 'Collega Google Calendar',
  'payments.success.title': 'Prenotazione confermata!',
  'payments.success.subtitle': 'Servizio prenotato con successo e pagamento completato.',
  'payments.order.confirmation': 'Conferma ordine',
  'payments.field.date': 'Data',
  'payments.field.time': 'Ora',
  'payments.field.address': 'Indirizzo servizio',
  'payments.contact.info': 'Informazioni di contatto',
  'payments.btn.add_calendar': 'Aggiungi al calendario',
  'payments.btn.download_receipt': 'Scarica ricevuta',
  'payments.btn.my_orders': 'Le mie prenotazioni',
  'company.back_to_search': 'Torna alla ricerca',
  'company.services_pricing': 'Servizi & Prezzi',
  'company.faq_details': 'FAQ & Dettagli',
  'company.whats_included': 'Cosa è incluso?',
  'company.why_choose': 'Perché scegliere questa azienda',
  'company.select_service': 'Seleziona servizio',
  'company.recent_reviews': 'Recensioni recenti',
  'company.member_since': 'Iscritto dal',
  'vendor.quotes.title': 'Gestione richieste di preventivo',
  'vendor.quotes.desc': 'Gestisci le richieste di preventivo dei clienti e rispondi con prezzi competitivi',
  'vendor.quotes.tabs.all': 'Tutte',
  'vendor.quotes.tabs.pending': 'In attesa',
  'vendor.quotes.tabs.quoted': 'Preventivo inviato',
  'vendor.quotes.tabs.accepted': 'Accettate',
  'vendor.quotes.no_requests_title': 'Nessuna richiesta di preventivo',
  'vendor.quotes.no_requests_all': 'Non hai ancora ricevuto richieste di preventivo.',
  'vendor.quotes.no_requests_filter': 'Nessuna richiesta {{status}} al momento.',
  'vendor.quotes.special_requests': 'Richieste speciali:',
  'vendor.quotes.your_quote': 'Il tuo preventivo:',
  'vendor.quotes.photos': 'Foto ({{count}})',
  'vendor.quotes.photo_label': 'Foto {{index}}',
  'vendor.quotes.send': 'Invia preventivo',
  'vendor.quotes.send_to': 'Invia preventivo a {{name}}',
  'vendor.quotes.send_desc': 'Indica il tuo prezzo e un messaggio per questa richiesta',
  'vendor.quotes.form.price': 'Prezzo (€)',
  'vendor.quotes.form.duration': 'Durata stimata (minuti)',
  'vendor.quotes.form.message': 'Messaggio',
  'vendor.quotes.form.message_placeholder': 'Spiega approccio, esperienza e eventuali considerazioni...',
  'vendor.quotes.btn.accept': 'Accetta',
  'vendor.quotes.btn.reject': 'Rifiuta',
  'vendor.quotes.toast.sent_title': 'Preventivo inviato',
  'vendor.quotes.toast.sent_desc': 'Preventivo di €{{price}} inviato.',
  'vendor.quotes.toast.status_updated': 'Stato aggiornato',
  'vendor.quotes.toast.status_changed': 'Stato della richiesta cambiato in {{status}}',
  'common.error': 'Errore',
  'calendar.title': 'Calendario interattivo',
  'calendar.desc': 'Visualizza e gestisci le prenotazioni. Clicca su una prenotazione per vedere i dettagli e aggiornare lo stato.',
  'calendar.badge.bookings': 'prenotazioni',
  'calendar.empty': 'Nessuna prenotazione per questa data',
  'calendar.today': 'Oggi',
  'calendar.tomorrow': 'Domani',
  'calendar.details.title': 'Dettagli prenotazione',
  'calendar.details.desc': 'Gestisci lo stato e visualizza le informazioni del cliente',
  'calendar.customer_info': 'Informazioni cliente',
  'calendar.service_details': 'Dettagli servizio',
  'calendar.field.service': 'Servizio:',
  'calendar.field.amount': 'Importo:',
  'calendar.field.notes': 'Note:',
  'calendar.status_mgmt': 'Gestione stato',
  'calendar.current_status': 'Stato attuale:',
  'calendar.update_status': 'Aggiorna stato:',
  'calendar.status.pending': 'In attesa',
  'calendar.status.confirmed': 'Confermata',
  'calendar.status.in_progress': 'In corso',
  'calendar.status.completed': 'Completata',
  'calendar.status.cancelled': 'Annullata',
  'calendar.reschedule.title': 'Ripianifica',
  'calendar.reschedule.new_date': 'Nuova data',
  'calendar.reschedule.start_time': 'Ora di inizio',
  'calendar.reschedule.helper': "Usa l'ora di inizio (es. 08:00)",
  'calendar.reschedule.save': 'Salva ripianificazione',
  'calendar.quick_actions.title': 'Azioni rapide',
  'calendar.quick_actions.call': 'Chiama',
  'calendar.quick_actions.email': 'Email',
  'calendar.quick_msgs.on_way': 'Siamo in arrivo',
  'calendar.quick_msgs.late': 'In ritardo di 10 minuti',
  'calendar.quick_msgs.access': 'Istruzioni di accesso?',
  'calendar.quick_msgs.parking': 'Confermi il parcheggio?',
  'calendar.quick_msgs.placeholder': 'Scrivi un messaggio...',
  'calendar.quick_msgs.copy_send': 'Invia',
  'calendar.quick_msgs.send_email': 'Invia via email',
  'calendar.toast.status_updated': 'Stato aggiornato',
  'calendar.toast.status_changed': 'Stato prenotazione cambiato in {{status}}',
  'calendar.toast.rescheduled': 'Prenotazione spostata al {{date}}',
  'calendar.toast.missing_fields': 'Seleziona data e ora',
  'onboard.services.title': 'Servizi & Prezzi',
  'onboard.services.desc': 'Aggiungi i servizi offerti per aiutare i clienti a capire cosa fornisci',
  'onboard.services.name': 'Nome servizio',
  'onboard.services.category': 'Categoria',
  'onboard.services.select_category': 'Seleziona una categoria',
  'onboard.services.description': 'Descrizione',
  'onboard.services.types_title': 'Tipologie di servizio (solo pulizie)',
  'onboard.services.types_helper': 'Conferma le tipologie offerte. Ai clienti verranno mostrate solo quelle selezionate.',
  'onboard.services.tags_title': 'Tag (sinonimi & parole chiave)',
  'onboard.services.tags_placeholder': 'Aggiungi un tag e premi Invio (es. pulizie, cleaning, vetri)',
  'onboard.services.pricing_type': 'Tipo di prezzo',
  'onboard.services.pricing.fixed': 'Prezzo fisso',
  'onboard.services.pricing.hourly': 'Per ora',
  'onboard.services.pricing.per_sqm': 'Per metro quadrato',
  'onboard.services.pricing.custom': 'Personalizzato',
  'onboard.services.base_price': 'Prezzo base (€)',
  'onboard.services.duration': 'Durata (minuti)',
  'onboard.services.vendor_covers_fee.title': 'Il vendor copre la fee del cliente',
  'onboard.services.vendor_covers_fee.desc': 'Se abilitato, la fee del cliente è a carico del vendor (il prezzo mostrato potrebbe rifletterlo).',
  'onboard.services.show_fee_disclaimer.title': 'Mostra disclaimer sulle fee ai clienti',
  'onboard.services.show_fee_disclaimer.desc': 'Mostra un disclaimer nel riepilogo: "Le fee del cliente sono coperte dal vendor."',
  'onboard.services.add_service': 'Aggiungi servizio',
  'onboard.services.added_services': 'Servizi aggiunti ({{count}})',
  'onboard.services.remove': 'Rimuovi',
  'onboard.services.continue_availability': 'Continua alla disponibilità',
  'onboard.welcome.subtitle': 'Impostiamo il profilo aziendale in pochi passaggi',
  'onboard.company.title': 'Informazioni azienda',
  'onboard.company.desc': 'Raccontaci della tua azienda per aiutare i clienti a trovarti e fidarsi dei tuoi servizi',
  'onboard.company.name': 'Nome azienda',
  'onboard.company.email': 'Email',
  'onboard.company.primary_categories': 'Categorie principali',
  'onboard.company.service_areas': 'Aree di servizio (Città o CAP)',
  'onboard.company.service_areas_ph': 'Aggiungi città o CAP e premi Invio',
  'onboard.company.service_areas_desc': 'Aggiungi tutte le città dove fornisci servizi. Più aree = più clienti possono trovarti!',
  'onboard.company.service_areas_suggestions': 'Aree popolari vicino a te:',
  'onboard.company.coverage_level': 'Livello di Copertura:',
  'onboard.company.coverage_national': 'Nazionale',
  'onboard.company.coverage_regional': 'Regionale',
  'onboard.company.coverage_local': 'Locale',
  'onboard.company.coverage_national_desc': 'Perfetto! Servi clienti in tutta Italia.',
  'onboard.company.coverage_regional_desc': 'Buona copertura regionale. Considera di aggiungere più aree.',
  'onboard.company.coverage_local_desc': 'Aggiungi più città per raggiungere più clienti.',
  'onboard.company.description': 'Descrizione',
  'onboard.company.description_ph': 'Descrivi la tua azienda e ciò che vi rende speciali...',
  'onboard.company.address': 'Indirizzo',
  'onboard.company.city': 'Città',
  'onboard.company.postal_code': 'CAP',
  'onboard.company.phone': 'Telefono',
  'onboard.company.tax_id': 'Partita IVA (Opzionale)',
  'onboard.company.website': 'Sito web (Opzionale)',
  'onboard.actions.continue_services': 'Continua ai servizi',
  'onboard.availability.title': 'Imposta disponibilità',
  'onboard.availability.desc': 'Configura gli orari di lavoro per facilitare le prenotazioni dei clienti',
  'onboard.availability.to': 'a',
  'onboard.actions.continue_review': 'Continua alla revisione',
  'onboard.review.title': 'Revisiona e completa',
  'onboard.review.desc': "Controlla le informazioni prima di completare l'onboarding",
  'onboard.review.company_info': 'Informazioni azienda',
  'onboard.review.services': 'Servizi ({{count}})',
  'onboard.review.availability': 'Disponibilità',
  'onboard.availability.not_available': 'Non disponibile',
  'onboard.actions.complete': 'Completa onboarding',
  'vendor.share_public': 'Condividi link pubblico',
  'vendor.toast.link_copied': 'Link copiato',
  'vendor.toast.link_desc': 'Link pubblico copiato negli appunti.',
  'auth.title.create': 'Crea account',
  'auth.title.welcome': 'Bentornato',
  'auth.subtitle.signup': 'Unisciti a Halomora per iniziare il tuo percorso',
  'auth.subtitle.signin': 'Accedi al tuo account per continuare',
  'auth.btn.loading': 'Caricamento...',
  'auth.btn.create': 'Crea account',
  'auth.btn.create_company': 'Crea account aziendale',
  'auth.btn.signin': 'Accedi',

  'auth.seo.title': 'Accedi o registrati | Halomora',
  'auth.back': 'Indietro',
  'auth.badge': 'Accesso piattaforma',
  'auth.panel.title': 'Accedi con un percorso più chiaro fin dal primo step.',
  'auth.panel.subtitle': 'Halomora accompagna clienti e aziende con un accesso più chiaro, affidabile e guidato. Scegli il tuo profilo e continua con il flusso più adatto al tuo caso.',
  'auth.panel.setup.title': 'Setup guidato',
  'auth.panel.setup.desc': 'Percorsi distinti per cliente e azienda, con onboarding progressivo e più leggibile.',
  'auth.panel.trust.title': 'Trust immediato',
  'auth.panel.trust.desc': 'Accesso, verifica email e policy spiegate in modo più comprensibile.',
  'auth.panel.convert.title': 'Pronto a convertire',
  'auth.panel.convert.desc': 'Lato azienda inizi dal profilo e poi completi l\'onboarding; lato cliente entri subito nel workspace.',
  'auth.panel.stat.paths': 'percorsi distinti',
  'auth.panel.stat.access': 'accesso centrale',
  'auth.panel.stat.friction': 'attriti visivi',
  'auth.brand_badge': 'Halomora access',
  'auth.tabs.customer': 'Cliente',
  'auth.tabs.company': 'Azienda',
  'auth.path.customer.title': 'Percorso cliente',
  'auth.path.customer.desc': 'Accedi velocemente al tuo dashboard, alle prenotazioni e ai flussi di supporto.',
  'auth.path.company.title': 'Percorso azienda',
  'auth.path.company.desc': 'Dopo l\'accesso continui con l\'onboarding azienda: dati profilo, servizi, prezzi e disponibilità.',
  'auth.form.full_name': 'Nome completo',
  'auth.form.company_name': 'Nome azienda o ragione sociale',
  'auth.form.company_hint': 'Questo dato avvia il profilo azienda e verrà ripreso nel passaggio successivo dell\'onboarding.',
  'auth.form.email': 'Email',
  'auth.form.password': 'Password',
  'auth.terms.prefix': 'Ho letto i',
  'auth.terms.link': 'Termini di servizio',
  'auth.privacy.prefix': 'Ho letto l\'',
  'auth.privacy.link': 'Informativa sulla privacy',
  'auth.btn.google': 'Continua con Google',
  'auth.switch.signin': 'Hai già un account? Accedi',
  'auth.switch.signup': 'Non hai un account? Registrati',
  'auth.resend.sending': 'Invio...',
  'auth.resend.text': 'Invia di nuovo email di verifica',
  'auth.validation.email': 'Inserisci un\'email valida',
  'auth.validation.password': 'La password deve avere almeno 6 caratteri',
  'auth.toast.email_required': 'Inserisci prima il tuo indirizzo email.',
  'auth.toast.error': 'Errore',
  'auth.toast.verification_sent_title': 'Email di verifica inviata!',
  'auth.toast.verification_sent_desc': 'Controlla la tua email e clicca sul link di verifica.',
  'auth.toast.resend_rate_limit_title': 'Troppi tentativi',
  'auth.toast.resend_rate_limit_desc': 'Hai richiesto troppi invii in poco tempo. Riprova tra qualche minuto.',
  'auth.toast.resend_failed': 'Impossibile reinviare l\'email di verifica.',
  'auth.toast.full_name_required': 'Il nome completo è obbligatorio per la registrazione.',
  'auth.toast.accept_legal_title': 'Accetta Termini e Informativa privacy',
  'auth.toast.accept_legal_desc': 'Devi accettare entrambi per creare un account.',
  'auth.toast.email_verified_title': 'Email verificata!',
  'auth.toast.email_verified_desc': 'La tua email è stata verificata. Ora puoi accedere.',
  'auth.toast.account_created_title': 'Account creato con successo!',
  'auth.toast.welcome': 'Benvenuto su Halomora!',
  'auth.toast.check_email': 'Controlla la tua email e clicca sul link di verifica per continuare.',
  'auth.toast.email_not_verified_title': 'Email non verificata',
  'auth.toast.email_not_verified_desc': 'Controlla la tua email e clicca sul link di verifica prima di accedere.',
  'auth.toast.profile_create_failed': 'Impossibile creare il profilo utente. Contatta il supporto.',
  'auth.toast.welcome_back_title': 'Bentornato!',
  'auth.toast.welcome_back_desc': 'Accesso effettuato con successo.',
  'auth.toast.profile_load_failed': 'Impossibile caricare il profilo. Riprova.',
  'auth.toast.signup_rate_limit_title': 'Troppi tentativi',
  'auth.toast.signup_rate_limit_desc': 'Per proteggere dagli abusi, l\'invio email è temporaneamente limitato. Attendi qualche minuto e riprova.',
  'auth.toast.unexpected_error': 'Si è verificato un errore imprevisto. Riprova.',
  'auth.toast.google_failed_title': 'Accesso con Google non riuscito',
  'auth.toast.validation_title': 'Errore di validazione',
  'auth.toast.validation_desc': 'Controlla i dati inseriti e riprova.',
  'booking.next': 'Prossimo passo',
  'booking.previous': 'Indietro',
  'booking.confirm': 'Conferma prenotazione',
  'header.switch_language': 'Lingua',

  // Header toasts & extras
  'header.toast.signed_out_title': 'Disconnesso',
  'header.toast.signed_out_desc': 'Sei stato disconnesso correttamente.',
  'nav.no_notifications': 'Nessuna notifica',
  'nav.support': 'Supporto',
  'nav.mark_read': 'Segna come letto',
  'nav.booking_ref': 'Prenotazione',
  'nav.sign_in_short': 'Accedi',
  'nav.join_company_short': 'Azienda',

  // Footer
  'footer.rights': '© {{year}} Halomora. Tutti i diritti riservati.',
  'footer.for_businesses': 'Per le aziende',
  'footer.apartment_manager': 'Property Manager',
  'footer.status': 'Stato',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Termini',
  'footer.cookies': 'Cookie',
  'footer.imprint': 'Note legali',
  'footer.subprocessors': 'Sub-fornitori',
  'footer.faq': 'FAQ',
  'footer.cookie_preferences': 'Preferenze cookie',

  // 404 / NotFound
  'notfound.seo_title': 'Pagina non trovata | Halomora',
  'notfound.heading': '404',
  'notfound.message': 'Ops! Pagina non trovata',
  'notfound.back_home': 'Torna alla home',

  // Status page
  'status.seo_title': 'Stato | Halomora',
  'status.seo_desc': 'Stato dei servizi e dei sistemi Halomora.',
  'status.heading': 'Stato del sistema',
  'status.env_label': 'Ambiente',
  'status.build_time': 'Ora di build',
  'status.badge.ok': 'attivo',
  'status.badge.degraded': 'rallentato',
  'status.badge.down': 'fuori servizio',
  'status.badge.unknown': 'sconosciuto',

  // Home page
  'home.seo.title': 'Halomora | Prenota servizi di pulizia e manutenzione vicino a te',
  'home.seo.description': 'Trova e prenota servizi per casa e azienda: pulizie, manutenzione, lavanderia, giardinaggio e altro. Aziende verificate, prezzo chiaro e recensioni.',
  'home.seo.results_title': 'Trova un servizio vicino a te | Halomora',
  'home.seo.results_description': 'Cerca aziende verificate e prenota servizi in pochi click. Filtra per città e tipologia.',
  'home.results.back_to_search': '← Torna alla ricerca',
  'home.results.loading': 'Caricamento risultati…',
  'home.hero.title': 'Tutto per la tua casa',
  'home.hero.subtitle': 'Tutti i servizi di cui hai bisogno in un unico posto — pulizie, manutenzione, lavanderia, giardinaggio, riparazioni e altro ancora. Prenota professionisti fidati per casa tua o la tua azienda in pochi minuti.',
  'home.hero.cta_start': 'Iniziamo!',
  'home.hero.cta_business': 'Per le aziende',
  'home.trust.professionals': 'Professionisti fidati',
  'home.trust.rating': 'Valutazione clienti',
  'home.trust.rating_reviews': 'da {{count}}+ recensioni',
  'home.trust.same_day': 'Prenota lo stesso giorno',
  'home.search.title': 'Trova e prenota in pochi secondi',
  'home.search.subtitle': 'Professionisti selezionati, prezzo chiaro e disponibilità immediata vicino a te.',
  'home.search.service_placeholder': 'Seleziona un servizio',
  'home.search.service.home_cleaning': 'Pulizie domestiche',
  'home.search.service.office_cleaning': 'Pulizie uffici',
  'home.search.service.gardening': 'Giardinaggio',
  'home.search.service.maintenance': 'Manutenzione',
  'home.search.service.laundry': 'Lavanderia',
  'home.search.service.disposal': 'Smaltimento ingombranti',
  'home.search.service.pest_control': 'Disinfestazioni',
  'home.search.city_placeholder': 'Città / zona',
  'home.search.when_placeholder': 'Quando',
  'home.search.when.today': 'Oggi',
  'home.search.when.tomorrow': 'Domani',
  'home.search.when.this_week': 'Questa settimana',
  'home.search.note': 'Potrai scegliere quando anche più avanti durante la prenotazione.',
  'home.search.cta': 'Cerca',
  'home.search.bulk_tooltip': 'Per apartment manager: carica fino a 30 ordini in un colpo (checkout/check-in).',
  'home.local.title': 'Servizi popolari nella tua zona',
  'home.local.subtitle': 'Trova professionisti verificati vicino a te',
  'home.local.companies_in': 'aziende a {{city}}',
  'home.apartment_mgr.eyebrow': 'Per apartment manager',
  'home.apartment_mgr.title': 'Ti manca ancora un partner pulizie continuativo per la stagione?',
  'home.apartment_mgr.desc': 'Se nelle località turistiche stai già faticando a trovare copertura affidabile, Halomora può aiutarti a strutturare un rapporto continuativo con aziende reputabili e poi collegarlo ai flussi operativi in app.',
  'home.apartment_mgr.cta_discover': 'Scopri il servizio',
  'home.apartment_mgr.cta_bulk': 'Vai a Bulk Order',
  'home.featured.title': 'Servizi in evidenza dai nostri partner più attivi',
  'home.featured.subtitle': 'Una selezione di servizi popolari e affidabili: prezzo chiaro, disponibilità e prenotazione in pochi click.',
  'home.featured.pro_pitch': "Sei un'azienda di servizi? Ottieni più visibilità e featured placement con PRO.",
  'home.featured.cta_pro': 'Diventa PRO',
  'home.featured.cta_plans': 'Scopri i piani',
  'home.testimonials.title': 'Cosa dicono i nostri clienti',
  'home.testimonials.subtitle': 'Recensioni reali da clienti che hanno prenotato su Halomora',
  'home.testimonials.verified_client': 'Cliente verificato',
  'home.features.title': 'Perché le aziende amano Halomora',
  'home.features.subtitle': "Vivi un'esperienza di prenotazione senza problemi, lavora con professionisti fidati e goditi una qualità garantita per tutte le tue esigenze di pulizia aziendale.",
  'home.features.ai.title': 'Matching basato su AI',
  'home.features.ai.desc': 'Raccomandazioni intelligenti basate sulle tue esigenze',
  'home.features.verified.title': 'Professionisti verificati',
  'home.features.verified.desc': 'Tutte le aziende sono controllate',
  'home.features.fast.title': 'Prenotazione veloce',
  'home.features.fast.desc': 'Prenota servizi in meno di 2 minuti',
  'home.features.quality.title': 'Qualità garantita',
  'home.features.quality.desc': 'Solo professionisti con valutazioni elevate',
  'home.provider.title': 'Sei un fornitore di servizi?',
  'home.provider.subtitle': 'Unisciti alla nostra piattaforma per far crescere la tua attività con strumenti intelligenti e clienti affidabili.',
  'home.provider.dashboard.title': 'Dashboard intelligente',
  'home.provider.dashboard.desc': 'Gestisci prenotazioni, traccia i guadagni e fai crescere la tua attività con la nostra dashboard intelligente.',
  'home.provider.pricing.title': 'Prezzi basati su AI',
  'home.provider.pricing.desc': 'Ottimizza i tuoi prezzi con insights basati su AI e analisi di mercato.',
  'home.provider.scheduling.title': 'Pianificazione facile',
  'home.provider.scheduling.desc': 'Gestione del calendario semplificata e conferme di prenotazione automatizzate.',
  'home.provider.cta': 'Inizia a far crescere la tua attività',
  'home.faq.title': 'Domande Frequenti',
  'home.faq.subtitle': 'Tutto quello che vuoi sapere sui nostri servizi',
  'home.faq.cat.types': 'Tipologie di servizio',
  'home.faq.cat.pricing': 'Prezzi e preventivi',
  'home.faq.cat.booking': 'Prenotazione e organizzazione',
  'home.faq.cat.quality': 'Qualità e materiali',
  'home.faq.cat.general': 'Generale',
  'home.faq.q.types_diff_q': 'Qual è la differenza tra pulizia di cambio e pulizia di fondo?',
  'home.faq.q.types_diff_a': "La pulizia di cambio è pensata per il cambio ospite/inquilino: rapida ed efficace, focalizzata su igiene e ordine. La pulizia di fondo è un intervento straordinario più approfondito, indicato dopo lunghi periodi di inutilizzo o quando serve un ripristino completo degli ambienti, compresi angoli e aree normalmente escluse dalla pulizia ordinaria.",
  'home.faq.q.refresh_q': 'Quando è utile il servizio di ripasso e controllo?',
  'home.faq.q.refresh_a': "Il ripasso è ideale come controllo qualità tra una pulizia e l'altra. Include riordino, rimozione di polvere superficiale e verifica generale dello stato di pulizia, per mantenere sempre un buon livello di presentabilità.",
  'home.faq.q.extra_q': 'Cosa include il servizio di pulizie straordinarie?',
  'home.faq.q.extra_a': 'Le pulizie straordinarie sono servizi personalizzati per esigenze specifiche: post-cantiere, dopo traslochi, trattamenti particolari su pavimenti e sanificazioni. Utilizziamo macchinari professionali e prodotti specifici per garantire risultati superiori.',
  'home.faq.q.price_calc_q': 'Come vengono calcolati i prezzi?',
  'home.faq.q.price_calc_a': "I prezzi dipendono dalla tipologia di servizio (ripasso, cambio, fondo o straordinario), dalla metratura dell'appartamento e dalle condizioni iniziali degli ambienti. Forniamo sempre un preventivo gratuito e dettagliato prima di iniziare.",
  'home.faq.q.price_fixed_q': 'I prezzi sono fissi o possono variare?',
  'home.faq.q.price_fixed_a': 'Per i servizi standard i prezzi sono fissi in base alla tipologia di appartamento. Per le pulizie straordinarie il prezzo è orario (30€/ora) e definito in base alle esigenze specifiche. Tutti i dettagli sono indicati nel preventivo.',
  'home.faq.q.discount_q': 'È possibile avere uno sconto per servizi ricorrenti?',
  'home.faq.q.discount_a': 'Sì, per clienti con servizi ricorrenti e frequenti valutiamo condizioni personalizzate. È sufficiente contattarci per trovare la soluzione più adatta.',
  'home.faq.q.advance_q': 'Quanto tempo prima devo prenotare?',
  'home.faq.q.advance_a': 'Consigliamo di prenotare con almeno 24–48 ore di anticipo, soprattutto in alta stagione. Per urgenze verifichiamo sempre la disponibilità.',
  'home.faq.q.cancel_q': 'Posso modificare o annullare una prenotazione?',
  'home.faq.q.cancel_a': "Sì, è possibile modificare o annullare fino a 24 ore prima dell'intervento senza costi aggiuntivi. Con meno preavviso possono applicarsi condizioni specifiche, comunicate in fase di prenotazione.",
  'home.faq.q.weekend_q': 'Operate anche nei weekend e nei giorni festivi?',
  'home.faq.q.weekend_a': 'Sì, operiamo anche nei weekend e nei giorni festivi, previa disponibilità del team. In questi casi potrebbero essere applicate delle maggiorazioni, indicate nel preventivo.',
  'home.faq.q.products_q': 'Portate voi i prodotti per la pulizia?',
  'home.faq.q.products_a': 'Sì, forniamo tutti i prodotti professionali necessari. Utilizziamo detergenti di alta qualità adatti a ogni superficie. Su richiesta possiamo usare prodotti specifici forniti dal cliente.',
  'home.faq.q.quality_q': 'Come garantite la qualità del servizio?',
  'home.faq.q.quality_a': "Ogni intervento segue procedure standardizzate ed è svolto da operatori qualificati. Su richiesta possiamo fornire un report fotografico finale. L'esperienza e la formazione continua del team garantiscono risultati eccellenti.",
  'home.faq.q.how_q': 'Come funziona Halomora?',
  'home.faq.q.how_a': "Cerca un servizio nella tua zona, confronta aziende verificate, prenota in pochi click e paga online o in contanti. Ricevi conferma immediata e il professionista arriva all'orario concordato.",
  'home.faq.q.verified_q': 'I professionisti sono verificati?',
  'home.faq.q.verified_a': 'Sì, tutte le aziende su Halomora sono verificate e hanno recensioni reali dai clienti. Mostriamo solo professionisti con valutazioni elevate e feedback positivi.',
  'home.faq.q.payment_q': 'Come funziona il pagamento?',
  'home.faq.q.payment_a': 'Puoi pagare online con carta di credito o in contanti al professionista. I pagamenti online sono sicuri e protetti. Ricevi sempre una ricevuta via email.',

  // FAQ page
  'faq.seo.title': 'FAQ | Halomora',
  'faq.seo.description': 'Domande frequenti per clienti e aziende: prenotazioni, pagamenti, preventivi, ricorrenze, cancellazioni e supporto.',
  'faq.page_title': 'Domande frequenti (FAQ)',
  'faq.page_subtitle': 'Istruzioni semplici per Clienti e Vendor',
  'faq.customer.section_title': 'FAQ Clienti (B2C e B2B)',
  'faq.vendor.section_title': 'FAQ Vendor (Aziende/Partner)',
  'faq.customer.home_flow.title': 'Clienti — Dalla Home alla prenotazione',
  'faq.customer.home_flow.items': 'Vai alla Home.\nScegli il tipo di servizio (es. Pulizia casa) e premi il pulsante.\nSe richiesto, inserisci la tua zona/indirizzo per vedere chi opera nella tua area.\nSeleziona l azienda preferita e poi premi Prenota sul servizio scelto per entrare nella pagina di prenotazione.',
  'faq.customer.single.title': 'Clienti — Prenotazione singola (una volta sola)',
  'faq.customer.single.items': 'Step 1 Programma: scegli data dal calendario e fascia oraria.\nStep 2 Dettagli servizio: scegli la tipologia, imposta i m² e l urgenza. Se non trovi ciò che ti serve, usa Richiedi un preventivo.\nStep 3 I tuoi dati: Nome, Cognome, Email, Telefono, Indirizzo del servizio. Se vuoi, spunta Usa lo stesso indirizzo per la fatturazione.\nStep 4 Riepilogo e conferma: controlla i dettagli, scegli il metodo di pagamento (Carta o Contanti al venditore, se disponibile) e premi Conferma prenotazione.',
  'faq.customer.recurring.title': 'Clienti — Prenotazione ricorrente (settimanale/mensile)',
  'faq.customer.recurring.items': 'In Step 1 Programma attiva il toggle Prenotazione ricorrente.\nScegli la Frequenza (settimanale/bisettimanale/mensile) e imposta una Data di fine.\nCompleta gli Step 2–4 come per la prenotazione singola. In riepilogo vedrai Occorrenze e Totale serie.',
  'faq.customer.quote.title': 'Clienti — Richiedere un preventivo personalizzato',
  'faq.customer.quote.items': 'In Step 2 Dettagli servizio premi Non trovi ciò che ti serve? Richiedi un preventivo.\nNella finestra Richiedi un preventivo inserisci superficie indicativa (se la conosci), note e (opzionale) foto.\nPremi Invia richiesta. Riceverai la risposta dal venditore via piattaforma/email.',
  'faq.customer.changes.title': 'Clienti — Modifiche, cancellazioni e rimborsi',
  'faq.customer.changes.items': 'Modifiche: vai su Profilo, apri la prenotazione e usa Modifica/Riprogramma (se disponibile).\nCancellazioni: da Profilo premi Annulla. Vedrai eventuali penali prima di confermare.\nRimborsi: se hai pagato con carta, il rimborso avviene online (tempi bancari 5–10 giorni). Per contanti, coordina con il venditore.',
  'faq.customer.auth.title': 'Clienti — Registrazione, accesso e ospite',
  'faq.customer.auth.items': 'Registrazione/Accesso: usa il pulsante Accedi / Registrati (pagina /auth).\nSenza account: in prenotazione, Step 3 I tuoi dati puoi fare Checkout come ospite.\nVantaggi dell account: ritrovi prenotazioni, puoi modificare/annullare più facilmente e gestire i tuoi dati.',
  'faq.customer.address.title': 'Clienti — Indirizzo, note e foto',
  'faq.customer.address.items': 'Indirizzo: inserisci via e numero civico per permettere al venditore di raggiungerti.\nNote: aggiungi richieste particolari in Istruzioni speciali.\nFoto: caricale in Step 2 per aiutare a capire meglio il lavoro.',
  'faq.customer.notifications.title': 'Clienti — Conferme, notifiche e ricevute',
  'faq.customer.notifications.items': 'Conferme: ricevi email di conferma dopo la prenotazione.\nPagamento carta: ricevi ricevuta via email.\nContanti: la ricevuta viene gestita dal venditore al momento del servizio.',
  'faq.customer.privacy.title': 'Clienti — Privacy e dati',
  'faq.customer.privacy.items': 'GDPR: i tuoi dati sono trattati secondo normativa.\nProfilo: puoi richiedere esportazione o cancellazione dei dati dal tuo profilo o contattando il supporto.',
  'faq.vendor.access.title': 'Vendor — Accesso e dashboard',
  'faq.vendor.access.items': 'Accedi/registrati dalla voce Accedi / Registrati.\nApri la tua Dashboard azienda dal menu.',
  'faq.vendor.profile_services.title': 'Vendor — Profilo e servizi',
  'faq.vendor.profile_services.items': 'Profilo azienda: carica logo, descrizione, aree coperte e contatti.\nServizi: crea/modifica con nome, descrizione, prezzo base, tipologie consentite, elementi inclusi/benefit.\nMetodi di pagamento: abilita Carta e/o Contanti al venditore per ogni servizio.',
  'faq.vendor.availability.title': 'Vendor — Disponibilità e capacità (evita overbooking)',
  'faq.vendor.availability.items': 'Imposta la capacità giornaliera per le date di lavoro.\nAggiorna per ferie o picchi. Le date piene vengono disabilitate nel calendario dei clienti.',
  'faq.vendor.bookings.title': 'Vendor — Gestione prenotazioni e ricorrenze',
  'faq.vendor.bookings.items': 'Inbox prenotazioni: le nuove richieste appaiono in cima (ricevi email se attive).\nRifiuto/Riprogrammazione: apri la prenotazione e usa le azioni dedicate, comunicando con il cliente.\nRicorrenze: visualizza occorrenze, sospendi singole date (se attivo), chiudi la serie se necessario.',
  'faq.vendor.quotes.title': 'Vendor — Preventivi personalizzati',
  'faq.vendor.quotes.items': 'Apri la sezione Preventivi.\nValuta metratura, note e foto.\nInvia proposta con prezzo, tempistiche e condizioni; se il cliente accetta, converti in prenotazione.',
  'faq.vendor.payments.title': 'Vendor — Pagamenti, rimborsi e dispute',
  'faq.vendor.payments.items': 'Pagamenti: per Carta trovi stato e ricevuta nella prenotazione; per Contanti emetti ricevuta secondo normativa.\nRimborsi: dal dettaglio prenotazione avvia rimborso totale/parziale secondo policy.\nDispute (chargeback): segui le notifiche e carica le prove; sospendi azioni sensibili finché la disputa è chiusa.',
  'faq.vendor.reporting.title': 'Vendor — Report e export',
  'faq.vendor.reporting.items': 'Dashboard: consulta prenotazioni, ricorrenze, ricavi, rimborsi e recensioni.\nExport: usa Esporta CSV quando disponibile per contabilità e analisi.',
  'faq.vendor.offers.title': 'Vendor — Offerte stagionali',
  'faq.vendor.offers.items': 'Apri la Dashboard e vai alla sezione Offerte.\nCrea un offerta con nome, sconto (%) e periodo.\nAssocia il servizio interessato e attiva l offerta.',
  'faq.vendor.paymethods.title': 'Vendor — Metodi di pagamento e fee',
  'faq.vendor.paymethods.items': 'Per ogni servizio abilita Carta e/o Contanti.\nSe copri le fee cliente, il prezzo mostrato al cliente le include.',
  'faq.vendor.cancel_policy.title': 'Vendor — Policy cancellazioni e rimborsi',
  'faq.vendor.cancel_policy.items': 'Definisci finestre e penali nelle impostazioni del servizio.\nNei rimborsi: usa il dettaglio prenotazione per totale/parziale secondo policy.',
  'faq.vendor.messaging.title': 'Vendor — Comunicazioni con i clienti',
  'faq.vendor.messaging.items': 'Usa note/descrizioni chiare nelle prenotazioni e preventivi.\nConferma rapidamente e avvisa tempestivamente in caso di variazioni.',
  'faq.vendor.security.title': 'Vendor — Dati e conformità',
  'faq.vendor.security.items': 'Mantieni aggiornati i dati aziendali e i contatti.\nGestisci documenti, ricevute e dati dei clienti secondo le norme vigenti.',

  // Legal pages + Landing + AuthReset + Auth
  'legal.last_updated': 'Ultimo aggiornamento: {{date}}',
  'legal.privacy.title': 'Informativa sulla privacy',
  'legal.privacy.open_link': 'Apri la Privacy Policy',
  'legal.privacy.fallback': 'Problemi di visualizzazione? Apri la policy su iubenda.com.',
  'legal.privacy.fallback_link': 'Apri la policy su iubenda.com',
  'legal.cookies.title': 'Cookie Policy',
  'legal.cookies.intro': 'Consulta la nostra Cookie Policy aggiornata e gestisci le preferenze sui cookie.',
  'legal.cookies.open_link': 'Apri la Cookie Policy',
  'legal.cookies.fallback_prefix': 'Se preferisci, puoi anche',
  'legal.cookies.fallback_link': 'aprire la cookie policy su iubenda.com',
  'legal.aup.title': 'Politica sull uso accettabile',
  'legal.aup.intro': 'Accetti di non usare i servizi per attività illecite, molestie, spam o qualsiasi azione che possa danneggiare altri, la piattaforma o i nostri partner.',
  'legal.aup.item.fraud': 'Nessuna condotta fraudolenta o ingannevole',
  'legal.aup.item.access': 'Nessun tentativo di accesso non autorizzato',
  'legal.aup.item.abuse': 'Nessun abuso o molestia verso fornitori o clienti',
  'legal.imprint.title': 'Note legali / Impressum',
  'legal.imprint.operator': 'Titolare',
  'legal.imprint.address': 'Indirizzo',
  'legal.imprint.email': 'Email',
  'legal.imprint.website': 'Sito web',
  'legal.imprint.vat': 'P. IVA / Codice fiscale',
  'legal.imprint.vat_value': '(se applicabile)',
  'legal.imprint.note': 'Questo sito funge da marketplace che mette in contatto clienti e fornitori indipendenti. I servizi sono erogati dai rispettivi fornitori. Per informazioni sul trattamento dei dati, consulta la nostra',
  'legal.imprint.privacy_link': 'Privacy Policy',
  'legal.refund.title': 'Politica di rimborso',
  'legal.refund.intro': 'Il diritto al rimborso dipende dal tipo di servizio, dai tempi di cancellazione e dalla conferma del fornitore. Se ritieni di aver diritto a un rimborso, contatta il supporto con i dettagli della prenotazione.',
  'legal.refund.cancellations_title': 'Cancellazioni',
  'legal.refund.cancellations_body': 'Le cancellazioni in giornata possono comportare una penale. Le mancate presentazioni (no-show) non sono generalmente rimborsabili.',
  'legal.subp.title': 'Sub-fornitori',
  'legal.subp.intro': 'Ci avvaliamo dei seguenti sub-fornitori per erogare i nostri servizi. Ogni sub-fornitore è vincolato da un Data Processing Agreement (DPA) con adeguate misure di sicurezza e tutele per i trasferimenti dati. Per l elenco aggiornato, consulta questa pagina o contattaci per maggiori dettagli.',
  'legal.subp.col.name': 'Nome',
  'legal.subp.col.purpose': 'Finalità',
  'legal.subp.col.location': 'Localizzazione',
  'legal.subp.col.dpa': 'DPA / Privacy',
  'legal.subp.learn_more': 'Maggiori informazioni',
  'legal.subp.supabase.purpose': 'Database Postgres gestito, autenticazione, storage',
  'legal.subp.vercel.purpose': 'Hosting applicazione & CDN',
  'legal.subp.stripe.purpose': 'Elaborazione pagamenti & payout',
  'legal.subp.resend.purpose': 'Consegna email transazionali',
  'legal.subp.google.purpose': 'Identity provider & sincronizzazione calendario',
  'legal.subp.iubenda.purpose': 'Hosting policy privacy & cookie / CMP',
  'legal.dpa.title': 'Data Processing Addendum (DPA)',
  'legal.dpa.intro': 'Questo DPA è parte integrante dei Termini e regola il trattamento dei dati personali da parte di Halomora per conto dei clienti. Include gli impegni in materia di sicurezza, riservatezza, sub-fornitori, diritti degli interessati e trasferimenti internazionali.',
  'legal.dpa.subp_title': 'Sub-fornitori',
  'legal.dpa.subp.supabase': 'Supabase (database e autenticazione)',
  'legal.dpa.subp.vercel': 'Vercel o Netlify (hosting)',
  'legal.dpa.subp.sentry': 'Sentry (monitoraggio errori) — opzionale',
  'legal.vendor.title': 'Accordo di Servizio per Fornitori',
  'legal.vendor.intro': 'Questo Accordo di Servizio per Fornitori ("Accordo") regola la partecipazione dei fornitori di servizi ("Fornitori") sulla piattaforma Halomora.',
  'legal.vendor.h1': '1. Obblighi del Fornitore',
  'legal.vendor.p1': 'I Fornitori devono mantenere licenze e assicurazioni valide, fornire descrizioni di servizio e prezzi accurati ed erogare i servizi con ragionevole diligenza e perizia.',
  'legal.vendor.h2': '2. Commissioni e payout',
  'legal.vendor.p2': 'Commissioni di piattaforma e calendario dei payout sono definiti dalle policy Halomora e possono essere aggiornati nel tempo con preavviso.',
  'legal.vendor.h3': '3. Agente di incasso limitato',
  'legal.vendor.p3': 'Il Fornitore nomina Halomora come proprio agente di incasso limitato al solo scopo di ricevere i pagamenti dei clienti tramite il nostro processore di pagamento e di trasferire tali fondi al Fornitore al netto di commissioni, imposte, chargeback o rimborsi applicabili. Il pagamento del cliente a Halomora è considerato pagamento al Fornitore. Halomora non è un istituto di pagamento e non gestisce fondi per conto del Fornitore oltre questa agenzia limitata.',
  'legal.vendor.h3b': 'Onboarding Stripe Connect',
  'legal.vendor.p3b': 'Halomora può utilizzare Stripe Connect per i payout. Il Fornitore accetta di completare l\'onboarding di Stripe (incluse verifica identità e configurazione del conto bancario) e di rispettare le condizioni di Stripe, nonché i requisiti antiriciclaggio e sanzioni applicabili.',
  'legal.vendor.h4': '4. Conformità',
  'legal.vendor.p4': 'I Fornitori si impegnano a rispettare le leggi applicabili e la nostra Politica sull\'uso accettabile. Il mancato rispetto può comportare la sospensione o la cessazione.',
  'legal.terms.title': 'Termini e condizioni',
  'legal.terms.notice': 'Versione italiana autoritativa. Le traduzioni in altre lingue sono fornite solo come supporto.',
  'landing.servizio.fallback_h1': 'Servizio non disponibile',
  'landing.servizio.search_cta': 'Cerca servizi',
  'landing.servizio.book_cta': 'Prenota ora',
  'landing.servizio.related_title': 'Servizi correlati a {{city}}',
  'landing.azienda.title_prefix': 'Aziende di pulizie a',
  'landing.azienda.subtitle': 'Confronta professionisti verificati nella tua zona, leggi le recensioni e prenota online.',
  'landing.azienda.cta_search': 'Trova aziende a {{city}}',
  'authreset.title': 'Reimposta la password',
  'authreset.subtitle': 'Inserisci una nuova password per il tuo account.',
  'authreset.new_password': 'Nuova password',
  'authreset.confirm_password': 'Conferma password',
  'authreset.cta': 'Aggiorna password',
  'authreset.loading': 'Aggiornamento in corso...',
  'authreset.success_title': 'Password aggiornata',
  'authreset.success_desc': 'La tua password è stata aggiornata correttamente. Ora puoi accedere.',
  'authreset.error_title': 'Errore',
  'authreset.error_mismatch': 'Le password non coincidono.',
  'authreset.error_short': 'La password deve avere almeno 8 caratteri.',
  'authreset.back_to_signin': 'Torna al login',
  'authreset.invalid_link': 'Il link di reset non è valido o è scaduto. Richiedi un nuovo link dalla pagina di accesso.',
  'auth.toggle.have_account': 'Hai già un account? Accedi',
  'auth.toggle.no_account': 'Non hai un account? Registrati',
  'auth.field.email': 'Email',
  'auth.field.password': 'Password',
  'auth.field.first_name': 'Nome',
  'auth.field.last_name': 'Cognome',
  'auth.field.phone': 'Telefono',
  'auth.forgot_password': 'Password dimenticata?',
  'auth.continue_with_google': 'Continua con Google',
  'auth.or': 'oppure',
  'auth.terms_notice': 'Continuando accetti i Termini e l Informativa sulla privacy.',
  'auth.send_reset_link': 'Invia link di reset',
  'auth.reset_sent_title': 'Email inviata',
  'auth.reset_sent_desc': 'Controlla la tua casella email per il link di reset.',

  // Landing servizio/azienda + AuthReset extras
  'landing.servizio.not_found_title': 'Servizio non trovato',
  'landing.servizio.not_found_body_prefix': 'Torna alla',
  'landing.servizio.not_found_body_link': 'homepage',
  'landing.servizio.not_found_body_suffix': 'per scoprire tutti i servizi.',
  'landing.servizio.cta_hero': 'Trova un Professionista',
  'landing.servizio.section_services': 'I nostri servizi',
  'landing.servizio.section_how': 'Come funziona',
  'landing.servizio.how_1_strong': 'Descrivi la tua esigenza',
  'landing.servizio.how_1_text': '— inserisci indirizzo e tipo di servizio',
  'landing.servizio.how_2_strong': 'Ricevi preventivi gratuiti',
  'landing.servizio.how_2_text': '— le imprese locali ti contattano entro 24h',
  'landing.servizio.how_3_strong': 'Scegli e prenota',
  'landing.servizio.how_3_text': '— confronta e conferma su Halomora',
  'landing.servizio.section_zones': 'Zone coperte',
  'landing.servizio.zones_body': 'Operiamo a {{zones}}. Contattaci per verificare la copertura nella tua zona specifica.',
  'landing.servizio.section_faq': 'Domande frequenti',
  'landing.servizio.cta_final_title': 'Pronto a prenotare?',
  'landing.servizio.cta_final_btn': 'Trova un Professionista a {{city}}',
  'landing.azienda.not_found_title': 'Pagina non trovata',
  'landing.azienda.not_found_body_prefix': 'Torna alla',
  'landing.azienda.not_found_body_link': 'homepage',
  'landing.azienda.hero_title': 'Fai Crescere la Tua Impresa di Pulizie a {{city}}',
  'landing.azienda.hero_body': 'Halomora mette in contatto le imprese di pulizie con clienti a {{city}} e nelle zone limitrofe ({{zones}}). Registrati gratuitamente e inizia a ricevere richieste nella tua zona.',
  'landing.azienda.cta_register': 'Registra la Tua Azienda',
  'landing.azienda.section_why': 'Perché usare Halomora',
  'landing.azienda.why_1_strong': 'Zero commissioni per iniziare',
  'landing.azienda.why_1_text': '— prova gratuita senza costi fissi',
  'landing.azienda.why_2_strong': 'Clienti geolocalizzati',
  'landing.azienda.why_2_text': '— richieste dalla tua zona di competenza',
  'landing.azienda.why_3_strong': 'Visibilità immediata',
  'landing.azienda.why_3_text': '— profilo visibile a chi cerca pulizie a {{city}}',
  'landing.azienda.why_4_strong': 'Gestione semplice',
  'landing.azienda.why_4_text': '— preventivi e appuntamenti in un unico posto',
  'landing.azienda.section_how': 'Come funziona',
  'landing.azienda.how_1_strong': 'Crea il tuo profilo gratuito',
  'landing.azienda.how_1_text': '— descrivi i servizi e la zona coperta',
  'landing.azienda.how_2_strong': 'Ricevi notifiche',
  'landing.azienda.how_2_text': '— avvisi per ogni nuova richiesta nella tua area',
  'landing.azienda.how_3_strong': 'Gestisci tutto da Halomora',
  'landing.azienda.how_3_text': '— preventivi, clienti e appuntamenti',
  'landing.azienda.section_zones': 'Zone coperte',
  'landing.azienda.zones_body': 'Operiamo a {{zones}}.',
  'landing.azienda.final_title': 'Sii tra i Primi a {{city}}',
  'landing.azienda.final_body': 'Le prime imprese iscritte ricevono visibilità prioritaria nelle ricerche della zona.',
  'authreset.validating': 'Validazione del link…',
  'authreset.go_signin': 'Vai al login',
  'authreset.try_from_profile': 'Riprova dal Profilo',
  'authreset.saving': 'Salvataggio…',
  'authreset.seo_title': 'Reimposta password | Halomora',
  'authreset.too_many_attempts_title': 'Troppi tentativi',
  'authreset.too_many_attempts_desc': 'Hai fatto troppi tentativi in poco tempo. Riprova tra qualche minuto.',
  'authreset.verification_required_title': 'Verifica richiesta',
  'authreset.verification_required_desc': 'Verifica con il codice del tuo authenticator per continuare.',
  'authreset.update_failed': 'Impossibile aggiornare la password.',
  'cookies.consent.message': "Usiamo i cookie per le funzionalità essenziali e per capire l'utilizzo. Leggi la nostra",
  'cookies.consent.cookie_policy': 'Cookie Policy',
  'cookies.consent.and': 'e la',
  'cookies.consent.privacy_policy': 'Privacy Policy',
  'cookies.consent.essential_only': 'Solo essenziali',
  'cookies.consent.accept_all': 'Accetta tutti',
  'cookies.preferences.title': 'Preferenze cookie',
  'cookies.preferences.analytics.title': 'Analytics & performance',
  'cookies.preferences.analytics.description': "Aiutaci a migliorare con metriche d'uso anonime e session replay.",
  'cookies.preferences.cancel': 'Annulla',
  'cookies.preferences.save': 'Salva preferenze',
  'support.seo_title': 'Supporto | Problemi e reclami | Halomora',
  'support.title': 'Problemi e reclami',
  'support.subtitle': 'Apri un ticket su una prenotazione, carica prove e segui lo stato.',
  'support.back_to_profile': 'Torna al profilo',
  'support.status.opened': 'Aperto',
  'support.status.awaiting_vendor': 'In attesa azienda',
  'support.status.awaiting_customer': 'In attesa cliente',
  'support.status.resolved': 'Risolto',
  'support.role.vendor': 'Azienda',
  'support.role.customer': 'Cliente',
  'support.role.system': 'Sistema',
  'support.toast.photos_upload_failed_title': 'Foto non caricate',
  'support.toast.photos_upload_failed_desc': 'Il ticket è stato creato, ma non sono riuscito a caricare le foto. Riprova oppure inviale come messaggio nel ticket.',
  'support.new_ticket.title': 'Apri un nuovo ticket',
  'support.new_ticket.select_booking': 'Seleziona prenotazione',
  'support.new_ticket.select_type': 'Tipo problema',
  'support.new_ticket.note_placeholder': 'Descrivi il problema (cosa è successo, quando, cosa ti aspetti).',
  'support.new_ticket.attach_evidence': 'Allega prove (foto)',
  'support.new_ticket.creating': 'Creazione…',
  'support.new_ticket.create': 'Crea ticket',
  'support.tickets.title': 'Ticket',
  'support.loading': 'Caricamento…',
  'support.fallback.service': 'Servizio',
  'support.fallback.company': 'Azienda',
  'support.fallback.issue': 'Problema',
  'support.empty_tickets': 'Nessun ticket ancora.',
  'support.select_ticket_hint': 'Seleziona un ticket a sinistra.',
  'support.ticket_title_fallback': 'Ticket',
  'support.ticket_meta.status': 'Stato',
  'support.ticket_meta.booking': 'Prenotazione',
  'support.empty_messages': 'Nessun messaggio.',
  'support.reply_placeholder': 'Rispondi…',
  'support.sending': 'Invio…',
  'support.send_reply': 'Invia risposta',
  'am.seo.title': 'Aziende di Pulizie Jesolo | Pulizie Appartamenti Veneto | Halomora per Property Manager',
  'am.seo.description': 'Cerchi aziende di pulizie a Jesolo o nel Veneto per i tuoi appartamenti? Halomora aiuta property manager e apartment manager a trovare partner affidabili, gestire turni con AI e tenere tutto sotto controllo in un\'unica piattaforma.',
  'am.hero.badge': 'Per property manager e apartment manager — Jesolo, Veneto e dintorni',
  'am.hero.title': 'Pulizie appartamenti a Jesolo? Gestisci tutto in un posto.',
  'am.hero.subtitle': 'Halomora ti aiuta a trovare aziende di pulizie affidabili nel Veneto, coordinare i turnover senza impazzire tra messaggi e telefonate, e tenere traccia di ogni intervento con una dashboard centralizzata. Dal booking singolo al batch da 50 prenotazioni in un clic.',
  'am.hero.cta_talk': 'Parliamone',
  'am.hero.cta_bulk': 'Hai già il fornitore? Usa Bulk Order',
  'am.hero.pill.verified': 'Aziende di pulizia verificate',
  'am.hero.pill.batch': 'Booking AI fino a 50 turni',
  'am.hero.pill.tower': 'Control Tower disponibilità live',
  'am.problem.title': 'Il problema di ogni stagione a Jesolo',
  'am.problem.p1': 'A Jesolo e nel Veneto balneare, le imprese di pulizie si esauriscono già tra marzo e aprile. Chi arriva tardi trova solo capacità residua.',
  'am.problem.p2': 'Gestire 10, 20 o 50 appartamenti con messaggi sparsi su WhatsApp e chiamate last minute è insostenibile in alta stagione.',
  'am.problem.p3': 'Halomora centralizza tutto: trovi i fornitori, prenoti in batch, vedi la disponibilità reale e tieni i conti in ordine — senza software aggiuntivi.',
  'am.features.title': 'Tutto quello che ti serve per gestire le pulizie',
  'am.features.subtitle': 'Una piattaforma pensata per chi gestisce appartamenti vacanze a Jesolo e nel Veneto — non software generico.',
  'am.fit.badge': 'È fatto per te se...',
  'am.fit.title': 'Pensato per chi gestisce appartamenti vacanze in Veneto',
  'am.fit.subtitle': 'Non serve essere una grande agenzia. Halomora è utile anche per chi gestisce 5–10 appartamenti a Jesolo e vuole smettere di inseguire i fornitori ogni stagione.',
  'am.fit.items': 'Gestisci più appartamenti o un portafoglio in crescita a Jesolo, Cavallino o Caorle.\nVuoi standard coerenti di pulizia senza dover rinegoziare ogni estate.\nHai bisogno di prenotare decine di turni in poco tempo senza errori.\nCerchi disponibilità reale, non conferme verbali che saltano all\'ultimo.',
  'am.how.title': 'Come funziona',
  'am.how.1.title': 'Analisi del fabbisogno',
  'am.how.1.text': 'Capacità, zone, tempi di turnover, standard qualitativi, picchi stagionali e criticità attuali.',
  'am.how.2.title': 'Selezione partner',
  'am.how.2.text': 'Valutiamo aziende di pulizie compatibili con i volumi richiesti e la continuità necessaria.',
  'am.how.3.title': 'Setup operativo',
  'am.how.3.text': 'Definiamo il perimetro del servizio e l\'interfaccia più pratica per gestire richieste e coordinamento.',
  'am.how.4.title': 'Gestione in piattaforma',
  'am.how.4.text': 'Quando ha senso, colleghiamo la gestione dei turnover a Bulk Order e agli altri flussi dell\'app.',
  'am.cta_find.badge': 'Non sai da dove iniziare?',
  'am.cta_find.title': 'Non hai ancora un fornitore? Ti aiutiamo a trovarlo.',
  'am.cta_find.body': 'Se non hai ancora una copertura pulizie continuativa per Jesolo o il Veneto, parti dal form qui sotto. Valutiamo insieme zona, volumi e frequenze, e ti mettiamo in contatto con partner adatti alla tua stagione. Se hai già il fornitore, puoi usare direttamente il Bulk Order in app.',
  'am.cta_find.btn_find': 'Trova un partner pulizie',
  'am.cta_find.btn_have': 'Hai già il fornitore',
  'am.batch.badge': 'Booking Batch con AI',
  'am.batch.title': '50 prenotazioni in un clic invece di ore di messaggi',
  'am.batch.body': 'Carica la lista dei tuoi appartamenti con checkout, check-in e finestre disponibili. L\'AI suggerisce la copertura ottimale, segnala i turni a rischio e ti dice esattamente dove confermare, anticipare o trovare un fornitore aggiuntivo. Niente più fogli Excel o chat disperse.',
  'am.batch.grid.apartments': 'Appartamenti',
  'am.batch.grid.apartments_desc': 'importa la lista',
  'am.batch.grid.windows': 'Finestre turno',
  'am.batch.grid.windows_desc': 'checkout → check-in',
  'am.batch.grid.ai': 'Copertura AI',
  'am.batch.grid.ai_desc': 'suggerita in automatico',
  'am.batch.grid.alert': 'Alert rischio',
  'am.batch.grid.alert_desc': 'slot da confermare',
  'am.batch.btn_talk': 'Parliamone',
  'am.batch.btn_try': 'Prova Bulk Order',
  'am.form.title': 'Richiedi un contatto',
  'am.form.success': 'Richiesta ricevuta. Ti ricontatteremo per capire copertura, tempistiche e volumi da gestire.',
  'am.form.contact_name': 'Nome referente',
  'am.form.company_name': 'Nome società / struttura',
  'am.form.email': 'Email di lavoro',
  'am.form.phone': 'Telefono',
  'am.form.area': 'Zona / località turistica',
  'am.form.apartments': 'Numero appartamenti / unità',
  'am.form.season': 'Periodo e continuità richiesta (es. aprile-settembre, 7/7)',
  'am.form.needs': 'Descrivi la tua esigenza: volumi, timing tra checkout e check-in, standard qualitativi, problemi con i fornitori attuali, aree da coprire.',
  'am.form.hint': 'Messaggio consigliato: raccontaci dove operi, quanti appartamenti gestisci e perché ti serve una copertura continuativa.',
  'am.form.submitting': 'Invio...',
  'am.form.sent': 'Richiesta inviata',
  'am.form.submit': 'Voglio essere ricontattato',
  'am.zones.title': 'Zone servite',
  'am.zones.items': 'Jesolo e litorale veneziano\nCavallino-Treporti e laguna\nCaorle, Bibione, Eraclea\nVenezia e comuni del Veneto',
  'am.links.title': 'Percorsi utili',
  'am.links.bulk': 'Bulk Order per turnover ricorrenti',
  'am.links.vendor': 'Sei un\'azienda di pulizie? Vedi come iscriverti',
  'am.links.search': 'Cerca servizi di pulizia',
  'am.faq.title': 'Domande frequenti',
  'am.faq.subtitle': 'Risposte rapide per capire se questo modello può fare al caso tuo.',
  'am.toast.sent_title': 'Richiesta inviata',
  'am.toast.sent_desc': 'Ti contatteremo al più presto per capire copertura, tempi e volumi.',
  'am.toast.failed_title': 'Invio non riuscito',
  'am.toast.failed_desc': 'Errore sconosciuto',
  'am.toast.error_send': 'Errore durante l\'invio della richiesta',
  'am.form.msg.contact': 'Referente:',
  'am.form.msg.apartments': 'Appartamenti/unità:',
  'am.form.msg.season': 'Periodo/operatività:',
  'am.form.msg.needs_label': 'Esigenza:',
  'am.form.msg.unspecified': '(non specificata)',
  'am.feature.1.title': 'Punto centralizzato per le aziende di pulizia',
  'am.feature.1.desc': 'Trova, valuta e prenota aziende di pulizie a Jesolo e nel Veneto in un unico posto. Profili verificati, recensioni reali, disponibilità aggiornata: niente più ricerca dispersa su WhatsApp o passaparola dell\'ultimo momento.',
  'am.feature.2.title': 'Dashboard centralizzata spese e servizi',
  'am.feature.2.desc': 'Tieni traccia di ogni intervento, spesa e fornitore in un\'unica dashboard. Vedi in un colpo d\'occhio i servizi più richiesti, i costi stagionali e come si distribuisce il lavoro tra i tuoi appartamenti.',
  'am.feature.3.title': 'Booking Batch con AI — fino a 50 prenotazioni',
  'am.feature.3.desc': 'Carica fino a 50 interventi in una sola operazione. L\'AI legge le finestre di turnover, suggerisce la copertura ottimale e segnala i turni a rischio: quello che prima richiedeva ore si riduce a minuti.',
  'am.feature.4.title': 'Turnover Control Tower in tempo reale',
  'am.feature.4.desc': 'Una vista live sulla disponibilità reale delle aziende di pulizia. Il calendario che vedi rispecchia la capacità effettiva dei fornitori: niente più conferme verbali che saltano all\'ultimo minuto.',
  'am.faq.1.q': 'Halomora è l\'azienda di pulizie o un intermediario?',
  'am.faq.1.a': 'Halomora opera come controparte organizzativa: seleziona aziende di pulizie reputabili a Jesolo e nel Veneto, struttura il servizio e resta il tuo punto di contatto operativo/commerciale. In base al caso, il lavoro viene poi eseguito in outsourcing da partner qualificati.',
  'am.faq.2.q': 'Per quali strutture è pensato il servizio?',
  'am.faq.2.a': 'È pensato per apartment manager, property manager e gestori di appartamenti vacanze che devono garantire turnover affidabili durante l\'alta stagione, soprattutto in destinazioni come Jesolo, Cavallino, Caorle, Bibione ed Eraclea dove la pressione operativa è massima da maggio a settembre.',
  'am.faq.3.q': 'Cosa significa \'Booking Batch con AI\'?',
  'am.faq.3.a': 'Invece di creare ogni prenotazione manualmente, puoi caricare fino a 50 interventi in una sola operazione — con finestre di turnover, appartamenti e date già compilate. L\'AI suggerisce la copertura ottimale e ti avvisa sugli slot a rischio.',
  'am.faq.4.q': 'Come funziona la Turnover Control Tower?',
  'am.faq.4.a': 'È una vista in tempo reale che mostra la disponibilità delle aziende di pulizia collegate. Quello che vedi a calendario rispecchia la disponibilità reale dei fornitori, non stime: sai subito chi può coprire il prossimo turno e dove c\'è rischio SLA.',
  'am.faq.5.q': 'Cosa succede dopo aver inviato il form?',
  'am.faq.5.a': 'Ti contattiamo per capire zona, numero di appartamenti, frequenza dei cambi, standard richiesti e criticità della stagione. Se c\'è fit operativo, ti proponiamo una soluzione continuativa con partner adatti alla tua area — Jesolo, Veneto e dintorni in priorità.',
  'business.nav.back_home': 'Torna alla Home',
  'business.seo.title': 'Sito Web, Gestionale e Clienti per Imprese di Pulizie | Halomora',
  'business.seo.description': 'Soluzioni per imprese di pulizie: sito web professionale, gestionale prenotazioni, calendario, pagamenti e clienti dal marketplace. Meno caos operativo, più richieste qualificate.',
  'business.hero.badge': 'Per imprese e aziende di pulizie',
  'business.hero.title': 'Sito web, gestionale e nuovi clienti per la tua impresa di pulizie',
  'business.hero.subtitle': 'Halomora ti aiuta a farti trovare online, ricevere richieste dal marketplace e gestire prenotazioni, calendario, pagamenti e team in un unico posto. Meno messaggi sparsi, più lavoro organizzato.',
  'business.hero.cta_signup': 'Registrati gratis',
  'business.hero.cta_how': 'Come funziona',
  'business.hero.stat1.label': '0€ per iniziare',
  'business.hero.stat1.sub': 'nessun abbonamento',
  'business.hero.stat2.label': 'Clienti dal marketplace',
  'business.hero.stat2.sub': 'non solo un gestionale',
  'business.hero.stat3.label': 'A partire dal 5%',
  'business.hero.stat3.sub': 'su ordini ricevuti',
  'business.showcase.label': 'La tua vetrina Halomora',
  'business.showcase.title': 'Visibile a chi cerca pulizie',
  'business.showcase.row1': 'Profilo azienda online',
  'business.showcase.row2': 'Servizi e prezzi pubblicati',
  'business.showcase.row3': 'Richieste dal marketplace',
  'business.showcase.row4': 'Calendario e ordini organizzati',
  'business.showcase.hint': 'Esempio di percorso tipico dopo la registrazione — in pochi minuti sei online.',
  'business.problem.badge': 'Il problema',
  'business.problem.title': 'Crescere con le pulizie non dovrebbe significare più caos',
  'business.problem.desc': 'Se ti riconosci in almeno uno di questi punti, Halomora è pensato per te.',
  'business.solution.badge': 'La soluzione',
  'business.solution.title': 'Sito, software gestionale e canale clienti — senza costi fissi',
  'business.solution.desc': 'Halomora unisce marketplace, vetrina online, booking e strumenti pratici per imprese di pulizie che vogliono vendere meglio e lavorare con meno sbatti.',
  'business.vitrine.badge': 'Mini sito gratuito',
  'business.vitrine.title': 'La tua vetrina professionale, pronta appena ti registri',
  'business.vitrine.desc': 'Non serve partire da un sito web costoso. Con Halomora hai subito una pagina azienda nel marketplace, condivisibile con clienti e visibile a chi cerca un\'impresa di pulizie nella tua zona.',
  'business.vitrine.lines': 'Pagina professionale con servizi, zone e contatti\nLink da inviare su WhatsApp, email o social\nPresenza nel marketplace Halomora\nPiù credibilità rispetto a un semplice numero di telefono',
  'business.vitrine.sample_url': 'halomora.com/tua-azienda',
  'business.vitrine.sample_name': 'Impresa Pulizie · Jesolo',
  'business.vitrine.sample_desc': 'Pulizie appartamenti, uffici e post-cantiere',
  'business.vitrine.custom_site': 'Vuoi un sito web dedicato per la tua impresa di pulizie, su dominio tuo e con form preventivo? Lo realizziamo come servizio opzionale su preventivo.',
  'business.vitrine.cta': 'Scopri sito web e marketing',
  'business.benefits.badge': 'Cosa ottieni',
  'business.benefits.title': 'Tutto quello che ti serve per lavorare meglio, in un solo posto',
  'business.benefits.desc': 'Software gestionale per prenotazioni, calendario, team e pagamenti — spiegato in modo semplice, con benefici concreti per la tua impresa di pulizie.',
  'business.free.badge_forever': 'Gratis per sempre',
  'business.free.badge_no_sub': 'Nessun abbonamento mensile',
  'business.free.title': 'Registrazione gratuita. Paghi solo quando ricevi ordini.',
  'business.free.desc': 'Halomora applica una commissione a partire dal 5% solo sugli ordini che ti arrivano tramite piattaforma (in base al piano). Nessun costo iniziale, nessuna sorpresa a fine mese.',
  'business.free.includes': 'Pagina azienda nel marketplace Halomora\nVetrina condivisibile con i tuoi clienti\nRichieste e prenotazioni da utenti della piattaforma\nCalendario, ordini e gestione team\nPagamenti tracciati e commissione trasparente (a partire dal 5% sugli ordini ricevuti)',
  'business.free.cta': 'Crea il profilo gratis',
  'business.free.hint': 'Circa 5 minuti · Nessuna carta richiesta per iniziare',
  'business.onboarding.badge': 'Inizia in 5 minuti',
  'business.onboarding.title': 'Quattro passi e sei operativo',
  'business.onboarding.desc': 'Niente burocrazia complicata. Ti guidiamo passo passo dalla registrazione ai primi ordini.',
  'business.optional.badge': 'Upgrade opzionale',
  'business.optional.title': 'Vuoi vendere di più online? Ti aiutiamo anche con sito web e marketing',
  'business.optional.desc': 'Il profilo Halomora resta gratuito. Realizzazione sito web per impresa di pulizie, SEO locale e campagne sono servizi su preventivo, per chi vuole accelerare la crescita.',
  'business.portfolio.badge': 'Esempio reale',
  'business.portfolio.title': 'Siti realizzati per aziende di pulizie',
  'business.portfolio.desc': 'Un esempio concreto del lavoro che possiamo fare per la tua impresa.',
  'business.portfolio.visit': 'Visita jservicejesolo.com',
  'business.portfolio.disclaimer': 'Il sito è di proprietà del cliente: lo mostriamo come riferimento di qualità e stile.',
  'business.testimonials.title': 'Cosa dicono le imprese che usano Halomora',
  'business.testimonials.company_fallback': 'Azienda',
  'business.cta.title': 'Pronto a ricevere più prenotazioni pulizie nella tua zona?',
  'business.cta.desc': 'Unisciti a Halomora gratis. Nessun abbonamento, nessun rischio iniziale — solo una commissione quando il lavoro arriva davvero.',
  'business.cta.signup': 'Registrati gratis ora',
  'business.cta.talk': 'Parla con noi',
  'business.local.title': 'Impresa di pulizie nella tua zona?',
  'business.local.desc': 'Pagine dedicate per imprese di pulizie che vogliono un sito, un gestionale e nuovi clienti a Jesolo, Venezia e nel Veneto.',
  'business.local.btn': 'Pulizie a {{city}}',
  'business.transparency': 'Trasparenza: Halomora non garantisce volumi fissi di clienti. I risultati dipendono da zona, stagionalità e qualità del profilo. Il nostro obiettivo è farti trovare più facilmente e lavorare in modo più ordinato.',
  'business.sales.title': 'Hai domande? Scrivici',
  'business.form.sent_title': 'Richiesta inviata!',
  'business.form.sent_desc': 'Ti ricontatteremo via email al più presto.',
  'business.form.company': 'Nome azienda',
  'business.form.email': 'Email di lavoro',
  'business.form.phone': 'Telefono (opzionale)',
  'business.form.region': 'Città / Regione',
  'business.form.interest': 'Cosa ti interessa?',
  'business.form.chip.free': 'Profilo gratuito',
  'business.form.chip.site': 'Sito web',
  'business.form.chip.site_mkt': 'Sito + marketing',
  'business.form.chip.mkt': 'Solo marketing',
  'business.form.message': 'Raccontaci della tua impresa di pulizie (zona, servizi, obiettivi)',
  'business.form.submitting': 'Invio…',
  'business.form.sent_btn': 'Inviata ✓',
  'business.form.submit': 'Invia',
  'business.faq.title': 'Domande frequenti',
  'business.plans.badge': 'Piani',
  'business.plans.title': 'Scegli il livello di supporto',
  'business.plans.desc': 'Puoi entrare gratis e passare a PRO o SCALE quando vuoi testare marketing con più supporto.',
  'business.plans.commission': 'Commissione: {{rate}}',
  'business.toast.failed_title': 'Invio non riuscito',
  'business.toast.failed_desc': 'Errore sconosciuto',
  'business.toast.error_send': 'Errore invio richiesta',
  'business.toast.thanks_title': 'Grazie!',
  'business.toast.thanks_desc': 'Richiesta inviata con successo. Ti ricontatteremo al più presto.',
  'business.period.month': '/mese',
  'business.period.from': 'Da',
  'business.period.quote': 'Su preventivo',
  'business.min.6': 'Minimo 6 mesi',
  'business.min.12': 'Minimo 12 mesi',
  'business.pain.1': 'Troppi messaggi sparsi su WhatsApp, email e fogli Excel.',
  'business.pain.2': 'Clienti che chiedono preventivi ma poi si perdono nel follow-up.',
  'business.pain.3': 'Difficile farsi trovare online senza un sito professionale, SEO locale o campagne fatte bene.',
  'business.pain.4': 'In alta stagione il rischio è dire sì a troppo lavoro e poi non reggere l\'organizzazione.',
  'business.pillar.1.title': 'Più clienti, senza costi fissi',
  'business.pillar.1.desc': 'Registrazione gratuita, nessun abbonamento mensile. Paghi una commissione solo quando ricevi un ordine tramite Halomora.',
  'business.pillar.2.title': 'Vetrina online e sito professionale',
  'business.pillar.2.desc': 'Ottieni una pagina professionale nel marketplace e, se vuoi, un sito per la tua impresa di pulizie con servizi, zone e form preventivo.',
  'business.pillar.3.title': 'Domanda dal marketplace',
  'business.pillar.3.desc': 'Gli utenti Halomora possono trovarti e prenotare direttamente. Non è solo un gestionale: porta anche richieste.',
  'business.benefit.1.title': 'Gestionale prenotazioni e incassi',
  'business.benefit.1.desc': 'Vedi ordini, pagamenti saldati e da saldare, fatture e stato delle prenotazioni senza saltare tra WhatsApp, Excel e app diverse.',
  'business.benefit.2.title': 'Calendario e team più ordinati',
  'business.benefit.2.desc': 'Pianifica le giornate, coordina il personale e riduci errori di doppia conferma o overbooking.',
  'business.benefit.3.title': 'Servizi e prezzi che convertono',
  'business.benefit.3.desc': 'Presenta meglio cosa offri, a che prezzo e per quali zone. Più chiarezza per il cliente, più richieste utili per te.',
  'business.benefit.4.title': 'Numeri semplici per vendere meglio',
  'business.benefit.4.desc': 'Capisci quali servizi portano richieste, come vanno le prenotazioni e dove conviene investire tempo, budget e personale.',
  'business.onboarding.1.title': 'Crea l\'account',
  'business.onboarding.1.text': 'Email e password oppure accesso con Google. Conferma l\'email e sei dentro.',
  'business.onboarding.2.title': 'Presenta la tua azienda',
  'business.onboarding.2.text': 'Nome, contatti, descrizione attività e foto profilo (consigliata). P.IVA opzionale.',
  'business.onboarding.3.title': 'Aggiungi servizi e prezzi',
  'business.onboarding.3.text': 'Indica cosa offri, per quali zone e a che prezzo. La commissione Halomora è chiara fin dall\'inizio.',
  'business.onboarding.4.title': 'Attiva i pagamenti',
  'business.onboarding.4.text': 'Collega il conto in pochi minuti per ricevere i bonifici direttamente quando lavori.',
  'business.tier.free.headline': 'Per testare il canale senza rischi.',
  'business.tier.pro.headline': 'Per testare seriamente con tracking e targeting locale.',
  'business.tier.scale.headline': 'Per scalare con ottimizzazione continua e landing dedicate.',
  'business.tier.ultra.headline': 'Gestione totale di social, brand e campagne. Su preventivo.',
  'business.tier.free.includes': 'Profilo azienda nel marketplace\nModulo richiesta preventivo\nGestione lead\nGestione prenotazioni e calendario\nPagamenti e fatturazione',
  'business.tier.free.excludes': 'Advertising\nSEO\nSupporto marketing avanzato',
  'business.tier.free.cta': 'Inizia gratis',
  'business.tier.pro.includes': 'Tutto il piano FREE\nProfilo azienda nel marketplace ottimizzato per conversione\nAnalytics (performance e andamento prenotazioni)\nSetup e gestione Google Ads\nBudget Ads (su Google) fino a 75€/mese\nTargeting locale\nTracking conversioni',
  'business.tier.scale.includes': 'Tutto il piano PRO\nLanding page dedicata con A/B testing\nBudget Ads (su Google) fino a 200€/mese\nOttimizzazione continua campagne\nLocal SEO base (Google Business Profile)\nReport mensile\nSupporto prioritario',
  'business.tier.ultra.includes': 'Tutto il piano SCALE\nGestione completa campagne social (creazione, copy, calendario)\nSetup e gestione Meta Ads (targeting, creatività, budget consigliato)\nGestione brand (linee guida, tono di voce, asset)\nConsulenza strategica e report dedicati\nSupporto dedicato (account manager)',
  'business.tier.free.name': 'PIANO FREE',
  'business.tier.free.price': '0€',
  'business.tier.free.commission': '15%',
  'business.tier.pro.name': 'PIANO PRO',
  'business.tier.pro.price': '99€',
  'business.tier.pro.commission': '10%',
  'business.tier.scale.name': 'PIANO SCALE',
  'business.tier.scale.price': '299€',
  'business.tier.scale.commission': '7%',
  'business.tier.ultra.name': 'PIANO ULTRA',
  'business.tier.ultra.price': '599€',
  'business.tier.ultra.commission': '5%',
  'business.tier.pro.cta': 'Crea il profilo e attiva PRO',
  'business.tier.scale.cta': 'Crea il profilo e attiva SCALE',
  'business.tier.ultra.cta': 'Prenota una call',
  'business.service.site.name': 'Sito web professionale',
  'business.service.site.headline': 'Un sito web professionale per la tua impresa di pulizie, pensato per ricevere richieste.',
  'business.service.site.cta': 'Richiedi preventivo sito',
  'business.service.site.bullets': 'Design custom mobile-first\nSEO locale base per città e servizi\nSezione servizi, zone, recensioni e contatti\nForm richieste preventivo integrato\n1-2 round di revisioni inclusi',
  'business.service.site_marketing.name': 'Sito + supporto marketing',
  'business.service.site_marketing.headline': 'Vetrina nuova + traffico qualificato in modo continuativo.',
  'business.service.site_marketing.cta': 'Richiedi sito + marketing',
  'business.service.site_marketing.bullets': 'Tutto del pacchetto sito\nSetup Google Ads con budget consigliato\nTracking conversioni (form, chiamate, WhatsApp)\nOttimizzazione campagne mensile\nReport mensile leggibile',
  'business.service.marketing.name': 'Solo supporto marketing',
  'business.service.marketing.headline': 'Hai già un sito e ti serve traffico, lead, copertura locale.',
  'business.service.marketing.cta': 'Richiedi solo marketing',
  'business.service.marketing.bullets': 'Audit Google Ads / Meta esistenti\nSetup nuove campagne (search, local, performance max)\nTracking conversioni e attribuzione\nOttimizzazione e budget management\nReport mensile con KPI commerciali',
  'business.template.free_signup': 'Ciao, vorrei creare il mio profilo azienda gratuito su Halomora.\n\nDati azienda:\n- Nome azienda: \n- Città / zona di lavoro: \n- Tipo di servizio principale (es. pulizie appartamenti, post-cantiere, uffici): \n- Anni di attività: \n- Sito web attuale (se esiste): \n- Contatto WhatsApp / telefono: \n- Note aggiuntive: \n',
  'business.template.site': 'Ciao, sono interessato a un sito web personalizzato per la mia azienda.\n\nDati progetto:\n- Nome azienda: \n- Città / zona di lavoro: \n- Settore (pulizie civili, industriali, post-cantiere, condomini, ecc.): \n- Sito web attuale (se esiste): \n- Hai già un dominio oppure serve aiuto per registrarlo? \n- Tempistiche desiderate per il go live: \n- Riferimenti / siti che ti piacciono (opzionale): \n- Budget orientativo: \n- Note aggiuntive: \n',
  'business.template.site_marketing': 'Ciao, sono interessato al pacchetto sito + supporto marketing.\n\nDati progetto:\n- Nome azienda: \n- Città / zona di lavoro: \n- Settore principale: \n- Sito web attuale (se esiste): \n- Stai già facendo pubblicità online? Su quali canali (Google, Meta, Tiktok)? \n- Obiettivo principale (es. acquisire clienti per area X, riempire stagione, post-cantiere): \n- Budget Ads mensile orientativo: \n- Tempistiche desiderate per il go live sito: \n- Note aggiuntive: \n',
  'business.template.marketing': 'Ciao, ho già un sito e vorrei supporto solo lato marketing.\n\nDati attuali:\n- Nome azienda: \n- Città / zona di lavoro: \n- Settore: \n- URL sito attuale: \n- Canali marketing attivi (Google Ads, Meta, SEO, volantinaggio, passaparola): \n- Spesa mensile attuale Ads: \n- Cosa vorresti migliorare (più lead, qualità lead, costo per lead, copertura, conversione): \n- Budget mensile orientativo: \n- Note aggiuntive: \n',
  'business.portfolio.jservice.client': 'JService',
  'business.portfolio.jservice.city': 'Jesolo (VE)',
  'business.portfolio.jservice.sector': 'Pulizie professionali, hospitality e turnover appartamenti',
  'business.portfolio.jservice.desc': 'Sito vetrina mobile-first con identità brand pulita e tono operativo. Pagine servizi, zone servite e FAQ pensate per convertire richieste qualificate.',
  'business.portfolio.jservice.highlights': 'Layout mobile-first con SEO base on-page\nSezioni servizi e zone servite ottimizzate per ricerche locali\nFAQ tematiche per ridurre attrito sui lead\nTono di voce coerente con il posizionamento aziendale',
  'business.faq.1.q': 'Halomora è solo un gestionale per imprese di pulizie?',
  'business.faq.1.a': 'No. È un marketplace che porta clienti, più una vetrina online gratuita, strumenti per gestire prenotazioni, calendario e pagamenti, e servizi opzionali per sito web e marketing.',
  'business.faq.2.q': 'Quanto costa iscriversi?',
  'business.faq.2.a': 'La registrazione è gratuita. Non c\'è abbonamento mensile. La commissione, a partire dal 5%, si applica solo agli ordini ricevuti tramite Halomora.',
  'business.faq.3.q': 'I clienti sono garantiti?',
  'business.faq.3.a': 'No. Dipende da zona, stagionalità e qualità del profilo. Halomora aumenta visibilità e organizzazione, non promette fatturato fisso.',
  'business.faq.4.q': 'Quanto tempo serve per attivarsi?',
  'business.faq.4.a': 'Circa 5–15 minuti per profilo e servizi. L\'attivazione pagamenti richiede pochi passaggi aggiuntivi.',
  'business.faq.5.q': 'Potete realizzare un sito web per la mia impresa di pulizie?',
  'business.faq.5.a': 'Sì. Possiamo realizzare un sito web professionale su dominio tuo, con pagine servizi, zone servite, form preventivo e collegamento al flusso Halomora. È un servizio opzionale su preventivo; il profilo marketplace resta gratuito.',
  'business.jsonld.faq.1.q': 'Halomora è solo un gestionale per imprese di pulizie?',
  'business.jsonld.faq.1.a': 'No. È un marketplace che porta clienti, più una vetrina online gratuita, strumenti per gestire prenotazioni, calendario e pagamenti, e servizi opzionali per sito web e marketing.',
  'business.jsonld.faq.2.q': 'Quanto costa iscriversi?',
  'business.jsonld.faq.2.a': 'La registrazione è gratuita. Non c\'è abbonamento mensile. La commissione, a partire dal 5%, si applica solo agli ordini ricevuti tramite Halomora.',
  'business.jsonld.faq.3.q': 'I clienti sono garantiti?',
  'business.jsonld.faq.3.a': 'No. Dipende da zona, stagionalità e qualità del profilo. Halomora aumenta visibilità e organizzazione, non promette fatturato fisso.',
  'business.jsonld.org.desc': 'Marketplace e piattaforma per imprese di pulizie: sito web, clienti, gestionale prenotazioni e lavoro più organizzato.',
  'business.jsonld.service.type': 'Sito web, marketplace e gestionale per imprese di pulizie',
  'business.jsonld.offer.free.name': 'Profilo gratuito',
  'business.jsonld.offer.free.desc': 'Profilo azienda nel marketplace, gestione prenotazioni pulizie. Commissione a partire dal 5% solo sugli ordini ricevuti.',
  'profile.subtitle': 'Gestisci impostazioni e preferenze del tuo account',
  'profile.back_to_dashboard': 'Torna alla Dashboard',
  'profile.my_account': 'Il Mio Account',
  'profile.upcoming': 'In arrivo',
  'profile.favourites': 'Preferiti',
  'profile.total_spent': 'Spesa Totale',
  'profile.orders': 'ordini',
  'profile.reschedule_booking': 'Riprogramma Prenotazione',
  'profile.new_date': 'Nuova Data',
  'profile.new_time': 'Nuovo Orario',
  'profile.reason': 'Motivo',
  'profile.cancel': 'Annulla',
  'profile.save': 'Salva',
  'profile.cancel_booking': 'Annulla Prenotazione',
  'profile.cancel_policy_notice': 'Annullando entro 48h il rimborso può ridursi: il fornitore e la piattaforma possono trattenere delle commissioni secondo la policy.',
  'profile.cost_breakdown': 'Dettaglio costi',
  'profile.total_paid': 'Totale pagato',
  'profile.vendor_cancel_fee': 'Componente fee cliente',
  'profile.platform_fee': 'Commissione piattaforma (Halomora)',
  'profile.estimated_refund': 'Rimborso stimato',
  'profile.ack_fee_retention': 'Confermo di aver compreso che la piattaforma e il venditore possono trattenere commissioni secondo la policy.',
  'profile.contact_vendor': 'Contatta il venditore',
  'profile.call_vendor': 'Chiama',
  'profile.back': 'Indietro',
  'profile.confirm_cancel': 'Conferma Annullamento',
  'profile.vendor_can_reschedule': 'Suggerimento: prova a contattare il venditore per una riprogrammazione gratuita, se concordata.',
  'profile.tab.billing': 'Fatturazione',
  'profile.my_quote_requests': 'Le Mie Richieste di Preventivo',
  'profile.no_quotes_yet': 'Nessun preventivo ancora.',
  'profile.awaiting_quote': 'In attesa del preventivo',
  'profile.requested_on': 'Richiesto il',
  'profile.accept': 'Accetta',
  'profile.reject': 'Rifiuta',
  'profile.filter_bookings': 'Filtra Prenotazioni',
  'profile.my_bookings': 'Le mie prenotazioni ({{count}})',
  'profile.download_statement': 'Scarica estratto conto',
  'profile.loading': 'Caricamento…',
  'profile.no_bookings_yet': 'Nessuna prenotazione ancora.',
  'profile.no_bookings_match': 'Nessuna prenotazione corrisponde ai filtri.',
  'profile.details': 'Dettagli',
  'profile.leave_review': 'Lascia recensione',
  'profile.reschedule': 'Riprogramma',
  'profile.cancel_action': 'Annulla',
  'profile.pay_now': 'Paga ora',
  'profile.fallback.service': 'Servizio',
  'profile.fallback.vendor': 'Fornitore',
  'profile.confirm_quote': 'Conferma preventivo',
  'profile.confirm_booking': 'Conferma prenotazione',
  'profile.quote_confirm_hint': 'Selezionando data e ora confermi la prenotazione al prezzo indicato nel preventivo.',
  'profile.personal_info': 'Informazioni personali',
  'profile.first_name': 'Nome',
  'profile.last_name': 'Cognome',
  'profile.nickname': 'Nickname',
  'profile.email': 'Email',
  'profile.phone': 'Telefono',
  'profile.bio': 'Bio',
  'profile.website': 'Sito web',
  'profile.save_changes': 'Salva modifiche',
  'profile.addresses_title': 'Indirizzi salvati',
  'profile.add_address': 'Aggiungi indirizzo',
  'profile.default': 'Predefinito',
  'profile.set_default': 'Imposta come predefinito',
  'profile.edit': 'Modifica',
  'profile.remove': 'Rimuovi',
  'profile.notifications_title': 'Preferenze notifiche',
  'profile.email_notifications': 'Notifiche email',
  'profile.sms_notifications': 'Notifiche SMS',
  'profile.push_notifications': 'Notifiche push',
  'profile.loyalty_title': 'Fidelity e vantaggi',
  'profile.security_title': 'Sicurezza',
  'profile.change_password': 'Cambia password',
  'profile.two_factor': 'Autenticazione a due fattori',
  'profile.enable_2fa': 'Attiva 2FA',
  'profile.disable_2fa': 'Disattiva 2FA',
  'profile.export_data': 'Esporta i miei dati',
  'profile.delete_account': 'Elimina account',
  'profile.seo.title': 'Il mio profilo | Halomora',
  'profile.toast.sign_in_required': 'Accesso richiesto',
  'profile.toast.sign_in_update': 'Accedi per aggiornare il profilo.',
  'profile.toast.sign_in_addresses': 'Accedi per salvare gli indirizzi.',
  'profile.toast.profile_missing': 'Profilo non trovato',
  'profile.toast.profile_missing_desc': 'Non abbiamo trovato il tuo profilo.',
  'profile.toast.profile_updated': 'Profilo aggiornato',
  'profile.toast.profile_updated_desc': 'Le informazioni del profilo sono state salvate.',
  'profile.toast.error': 'Errore',
  'profile.toast.address_added': 'Indirizzo aggiunto',
  'profile.toast.address_added_desc': 'Il nuovo indirizzo è stato aggiunto.',
  'profile.toast.address_updated': 'Indirizzo aggiornato',
  'profile.toast.address_updated_desc': 'Il tuo indirizzo è stato aggiornato.',
  'profile.toast.address_removed': 'Indirizzo rimosso',
  'profile.toast.address_removed_desc': 'L\'indirizzo è stato rimosso.',
  'profile.toast.default_updated': 'Predefinito aggiornato',
  'profile.toast.default_updated_desc': 'Questo indirizzo è ora il predefinito.',
  'profile.toast.payment_added': 'Metodo di pagamento aggiunto',
  'profile.toast.payment_removed': 'Metodo di pagamento rimosso',
  'profile.toast.notifications_updated': 'Impostazioni notifiche aggiornate',
  'profile.toast.export_ready': 'Esportazione pronta',
  'profile.toast.export_ready_desc': 'I tuoi dati sono stati scaricati.',
  'profile.toast.account_deletion': 'Eliminazione account richiesta',
  'profile.toast.review_sent': 'Recensione inviata',
  'profile.toast.review_sent_desc': 'Grazie per il tuo feedback!',
  'profile.toast.review_exists': 'Già recensito',
  'profile.toast.rescheduled': 'Riprogrammata',
  'profile.toast.cancelled': 'Annullata',
  'profile.toast.booking_created': 'Prenotazione creata',
  'profile.toast.booking_created_desc': 'La prenotazione è stata confermata al prezzo del preventivo.',
  'profile.toast.preferences_updated': 'Preferenze aggiornate',
  'profile.toast.consent_updated': 'Consenso aggiornato',
  'profile.toast.mfa_enabled': '2FA attivata',
  'profile.toast.mfa_enabled_desc': 'L\'autenticazione a due fattori è ora attiva.',
  'profile.toast.mfa_disabled': '2FA disattivata',
  'profile.toast.email_sent': 'Email inviata',
  'profile.toast.email_sent_desc': 'Controlla la casella email per reimpostare la password.',
  'profile.toast.rate_limit': 'Troppi tentativi',
  'profile.toast.rate_limit_reset': 'Hai richiesto troppi reset in poco tempo. Riprova tra qualche minuto.',
  'profile.validation.first_name': 'Il nome è obbligatorio',
  'profile.validation.last_name': 'Il cognome è obbligatorio',
  'profile.validation.email': 'Indirizzo email non valido',
  'profile.validation.phone': 'Il telefono deve avere almeno 10 cifre',
  'profile.validation.label': 'L\'etichetta è obbligatoria',
  'profile.validation.address': 'L\'indirizzo è obbligatorio',
  'profile.validation.city': 'La città è obbligatoria',
  'profile.validation.state': 'La provincia è obbligatoria',
  'profile.validation.postal': 'Il CAP è obbligatorio',
  'profile.validation.country': 'Il paese è obbligatorio',
  'profile.review.title': 'Lascia una recensione',
  'profile.review.rating': 'Valutazione',
  'profile.review.comment_optional': 'Commento (opzionale)',
  'profile.review.placeholder': 'Com\'è andata? Cosa ti è piaciuto?',
  'profile.review.submit': 'Invia recensione',
  'profile.review.submitting': 'Invio…',
  'profile.download_receipt': 'Scarica ricevuta',
  'profile.mfa.starting': 'Avvio…',
  'profile.mfa.start_setup': 'Avvia configurazione',
  'profile.mfa.verifying': 'Verifica…',
  'profile.mfa.verify_enable': 'Verifica e attiva',
  'profile.mfa.disabling': 'Disattivazione…',
  'profile.mfa.disable': 'Disattiva 2FA',
  'profile.mfa.load_failed': 'Impossibile caricare lo stato 2FA',
  'profile.mfa.setup_failed': 'Impossibile avviare la configurazione 2FA',
  'profile.mfa.invalid_code': 'Codice non valido',
  'profile.mfa.disable_failed': 'Impossibile disattivare la 2FA',
  'profile.toast.update_failed': 'Impossibile aggiornare il profilo.',
  'profile.toast.add_address_failed': 'Impossibile aggiungere l\'indirizzo',
  'profile.toast.set_default_failed': 'Impossibile impostare il predefinito',
  'profile.toast.update_address_failed': 'Impossibile aggiornare l\'indirizzo',
  'profile.toast.remove_address_failed': 'Impossibile rimuovere l\'indirizzo',
  'profile.toast.export_failed': 'Impossibile esportare i dati',
  'profile.toast.delete_failed': 'Impossibile eliminare l\'account',
  'profile.toast.account_deletion_desc': 'Il tuo account è stato anonimizzato e contrassegnato come eliminato.',
  'profile.toast.payment_added_desc': 'Il nuovo metodo di pagamento è stato aggiunto.',
  'profile.toast.payment_removed_desc': 'Il metodo di pagamento è stato rimosso.',
  'profile.toast.notifications_enabled': '{{type}} attivato.',
  'profile.toast.notifications_disabled': '{{type}} disattivato.',
  'profile.validation.card_number': 'Il numero carta deve avere 16 cifre',
  'profile.validation.cardholder': 'Il nome titolare è obbligatorio',
  'profile.validation.expiry_month': 'Il mese di scadenza è obbligatorio',
  'profile.validation.expiry_year': 'L\'anno di scadenza è obbligatorio',
  'profile.validation.cvv': 'Il CVV deve avere almeno 3 cifre',
  'profile.toast.mfa_disabled_title': '2FA disattivata',
  'profile.toast.login_required': 'Accesso richiesto',
  'profile.toast.login_required_desc': 'Accedi di nuovo e riprova.',
  'profile.toast.invalid_rating': 'Valutazione non valida',
  'profile.toast.invalid_rating_desc': 'Seleziona una valutazione da 1 a 5.',
  'profile.toast.missing_company': 'Azienda mancante',
  'profile.toast.missing_company_desc': 'A questa prenotazione manca company_id.',
  'profile.toast.review_not_allowed': 'Non consentito',
  'profile.toast.review_not_allowed_desc': 'Puoi recensire solo prenotazioni completate effettuate dal tuo account.',
  'profile.toast.review_failed': 'Impossibile inviare la recensione',
  'profile.toast.payment_unavailable': 'Pagamento non disponibile',
  'profile.toast.payment_unavailable_desc': 'Nessun importo pagabile per questa prenotazione.',
  'profile.toast.payment_error': 'Errore pagamento',
  'profile.toast.payment_error_desc': 'Impossibile avviare il checkout',
  'profile.toast.missing_fields': 'Campi mancanti',
  'profile.toast.missing_fields_reschedule': 'Data, ora e motivo sono obbligatori',
  'profile.toast.blocked': 'Bloccato',
  'profile.toast.blocked_reschedule': 'Non puoi riprogrammare entro 48 ore dall\'appuntamento.',
  'profile.toast.reschedule_failed': 'Impossibile riprogrammare',
  'profile.toast.reason_required': 'Motivo obbligatorio',
  'profile.toast.reason_required_desc': 'Indica un motivo per l\'annullamento',
  'profile.toast.cancelled_title': 'Prenotazione annullata',
  'profile.toast.cancel_failed': 'Impossibile annullare',
  'profile.toast.update_failed_generic': 'Impossibile aggiornare',
  'profile.toast.quote_accept_failed': 'Impossibile accettare il preventivo',
  'profile.toast.pick_date_time': 'Scegli data e ora',
  'profile.toast.review_exists_desc': 'Hai già lasciato una recensione per questa prenotazione.',
  'profile.nickname_optional': 'Nickname (opzionale)',
  'profile.email_address': 'Indirizzo email',
  'profile.phone_number': 'Numero di telefono',
  'profile.notifications_privacy_title': 'Comunicazioni e privacy',
  'profile.service_comms_title': 'Preferenze comunicazioni di servizio',
  'profile.service_comms_desc': 'Questa scelta viene salvata nel tuo profilo per limitare le comunicazioni al minimo indispensabile. Aggiornamenti importanti su prenotazioni, modifiche o assistenza potranno comunque arrivarti quando necessari.',
  'profile.marketing_consent': 'Consenso marketing',
  'profile.consent_history': 'Storico consensi',
  'profile.terms_accepted': 'Termini accettati',
  'profile.privacy_accepted': 'Privacy accettata',
  'profile.consent_date': 'Data consenso',
  'profile.not_available': 'n/d',
  'profile.update_to_latest': 'Aggiorna al testo corrente',
  'profile.loyalty_card_title': 'Sconti e vantaggi Halomora',
  'profile.loyalty_coming_soon': 'Una sezione pensata per tornare utile presto',
  'profile.loyalty.discount_codes': 'Codici sconto',
  'profile.loyalty.no_codes': 'Nessun codice attivo',
  'profile.loyalty.promo_credits': 'Crediti promozionali',
  'profile.loyalty.promo_credits_desc': 'In futuro potrai vedere eventuali crediti utilizzabili sulle prossime prenotazioni.',
  'profile.loyalty.coming_soon_badge': 'In arrivo',
  'profile.loyalty.benefits': 'Vantaggi fedeltà',
  'profile.loyalty.benefits_desc': 'Promozioni dedicate, iniziative stagionali e benefici riservati ai clienti più attivi appariranno qui.',
  'profile.loyalty.area_ready': 'Area pronta',
  'profile.field.label': 'Etichetta',
  'profile.website_optional': 'Sito web (opzionale)',
  'profile.bio_optional': 'Bio (opzionale)',
  'profile.bio_placeholder': 'Raccontaci qualcosa di te...',
  'profile.date': 'Data',
  'profile.time': 'Ora',
  'profile.add_new_address': 'Aggiungi nuovo indirizzo',
  'profile.add_address_dialog_desc': 'Aggiungi un nuovo indirizzo al tuo profilo.',
  'profile.address_line1': 'Indirizzo riga 1',
  'profile.address_line2_optional': 'Indirizzo riga 2 (opzionale)',
  'profile.city': 'Città',
  'profile.state': 'Provincia',
  'profile.postal_code': 'CAP',
  'profile.country': 'Paese',
  'profile.add_address_btn': 'Aggiungi indirizzo',
  'profile.edit_address': 'Modifica indirizzo',
  'profile.payment_methods_title': 'Metodi di pagamento',
  'profile.add_payment_method': 'Aggiungi metodo di pagamento',
  'profile.add_payment_dialog_title': 'Aggiungi nuovo metodo di pagamento',
  'profile.add_payment_dialog_desc': 'Aggiungi un nuovo metodo di pagamento al profilo.',
  'profile.card_number': 'Numero carta',
  'profile.cardholder_name': 'Nome titolare',
  'profile.expiry_month': 'Mese scadenza',
  'profile.expiry_year': 'Anno scadenza',
  'profile.cvv': 'CVV',
  'profile.add_payment_btn': 'Aggiungi metodo di pagamento',
  'profile.expires': 'Scade {{date}}',
  'profile.notifications_intro': 'Qui puoi salvare le tue preferenze per ridurre al minimo le comunicazioni non necessarie. Se però hai una prenotazione attiva o c\'è un aggiornamento importante sul servizio, alcune comunicazioni operative essenziali potranno comunque essere inviate.',
  'profile.marketing_desc': 'Se lo lasci attivo, Halomora potrà inviarti comunicazioni commerciali selezionate e contenuti utili pensati per aiutarti a prenotare meglio.',
  'profile.marketing.benefit1': 'Codici sconto e offerte riservate',
  'profile.marketing.benefit2': 'Promozioni stagionali e novità utili',
  'profile.marketing.benefit3': 'Selezioni di fornitori e servizi in evidenza',
  'profile.marketing.benefit4': 'Comunicazioni dedicate dal team Halomora',
  'profile.marketing_opt_out_note': 'Se lo disattivi, eviterai comunicazioni promozionali e commerciali da parte di Halomora, ma potresti perderti vantaggi dedicati e opportunità riservate.',
  'profile.terms_accepted_label': 'Termini accettati:',
  'profile.privacy_accepted_label': 'Privacy accettata:',
  'profile.consent_date_label': 'Data consenso:',
  'profile.loyalty_intro1': 'Qui troverai i codici sconto assegnati da Halomora, eventuali crediti promozionali e i vantaggi dedicati al tuo account.',
  'profile.loyalty_intro2': 'Per ora non ci sono promozioni attive sul tuo profilo, ma questa area resterà pronta per mostrarti benefit e offerte in modo chiaro.',
  'profile.loyalty.coupon_desc': 'Quando Halomora ti assegnerà un coupon, lo vedrai qui con valore, scadenza e condizioni d\'uso.',
  'profile.security.change_password_desc': 'Proteggi il tuo account con una password robusta.',
  'profile.security.change_password_btn': 'Cambia password',
  'profile.security.manage_2fa': 'Gestisci 2FA',
  'profile.security.enable_2fa': 'Attiva 2FA',
  'profile.mfa.dialog_title': 'Autenticazione a due fattori (TOTP)',
  'profile.mfa.dialog_desc': 'Usa Google Authenticator, 1Password o un\'app TOTP.',
  'profile.mfa.status_label': 'Stato:',
  'profile.mfa.status_enabled': 'Attiva',
  'profile.mfa.status_disabled': 'Non attiva',
  'profile.mfa.enabled_message': 'La 2FA è attiva per il tuo account.',
  'profile.mfa.scan_qr': 'Scansiona questo codice QR con la tua app di autenticazione:',
  'profile.mfa.uri_hint': 'Se non puoi scansionare, usa questo URI:',
  'profile.mfa.enter_code': 'Inserisci il codice a 6 cifre:',
  'profile.security.session_title': 'Gestione sessioni',
  'profile.security.session_desc': 'Visualizza e gestisci le sessioni attive.',
  'profile.security.manage_sessions': 'Gestisci sessioni',
  'profile.security.active_session': 'Sessione attiva',
  'profile.security.active_session_desc': '{{email}} • dal {{since}}',
  'profile.export_json': 'Esporta JSON',
  'profile.delete_account_btn': 'Elimina account',
  'profile.toast.notification_type_enabled': '{{type}} attivato.',
  'profile.toast.notification_type_disabled': '{{type}} disattivato.',
  'profile.billing.title': 'Dati di fatturazione',
  'profile.billing.subtitle': 'Usati per precompilare la richiesta fattura in fase di prenotazione. Compilali per ricevere fatture senza inserirli ogni volta.',
  'profile.billing.type': 'Tipo',
  'profile.billing.type_private': 'Privato (persona fisica)',
  'profile.billing.type_company': 'Azienda / Partita IVA',
  'profile.billing.first_name': 'Nome *',
  'profile.billing.last_name': 'Cognome *',
  'profile.billing.address': 'Indirizzo di fatturazione *',
  'profile.billing.tax_code': 'Codice Fiscale *',
  'profile.billing.business_name': 'Ragione sociale oppure Nome e Cognome *',
  'profile.billing.company_address': 'Indirizzo della sede *',
  'profile.billing.sdi_code': 'Codice Univoco SDI (7 caratteri) *',
  'profile.billing.saving': 'Salvataggio...',
  'profile.billing.save': 'Salva dati di fatturazione',
  'profile.billing.invalid': 'Dati non validi',
  'profile.billing.saved': 'Salvato',
  'profile.billing.saved_desc': 'I dati di fatturazione sono stati aggiornati.',
  'profile.billing.save_failed': 'Salvataggio non riuscito',
  'profile.billing.placeholder_first': 'Mario',
  'profile.billing.placeholder_last': 'Rossi',
  'profile.billing.placeholder_address': 'Via Roma 1, 00100 Roma',
  'profile.billing.placeholder_tax': 'RSSMRA80A01H501Z',
  'profile.billing.placeholder_company': 'Es. Acme S.r.l.',
  'profile.billing.placeholder_sdi': 'M5UXCR1',
  'profile.export_data_desc': 'Scarica una copia dei tuoi dati personali in formato JSON.',
  'profile.close': 'Chiudi',
  'profile.rate_star': 'Valuta {{n}}',
  'profile.mailto.reschedule_subject': 'Richiesta riprogrammazione prenotazione {{number}}',
  'dash.export_csv': 'Esporta CSV',
  'dash.export_json': 'Esporta JSON',
  'dash.kpi.total_spent': 'Spesa totale',
  'dash.kpi.total_orders': 'Prenotazioni totali',
  'dash.kpi.aov': 'Valore medio ordine',
  'dash.kpi.loyalty': 'Punti fedeltà',
  'dash.kpi.from_last_month': 'rispetto al mese scorso',
  'dash.kpi.points_hint': 'Disponibili per i premi',
  'dash.seo.title': 'Dashboard | Halomora',
  'company_profile.loading': 'Caricamento...',
  'company_profile.company_not_found': 'Azienda non trovata',
  'company_profile.back_to_dashboard': 'Torna alla Dashboard',
  'company_profile.title': 'Profilo Azienda',
  'company_profile.subtitle': 'Gestisci le informazioni della tua azienda e i servizi',
  'company_profile.tab.company_info': 'Info Azienda',
  'company_profile.tab.services': 'Servizi',
  'company_profile.tab.security': 'Sicurezza',
  'company_profile.export_data': 'Esporta dati',
  'company_profile.delete_account': 'Elimina account',
  'company_profile.company_information': 'Informazioni Azienda',
  'company_profile.update_details': 'Aggiorna i dettagli della tua azienda che vedranno i clienti',
  'company_profile.vendor_data_consent': 'Consenso dati venditore',
  'company_profile.allow_aggregated_data': 'Consenti l\'uso di dati operativi aggregati e anonimizzati.',
  'company_profile.customer_data_consent': 'Consenso dati cliente',
  'company_profile.gate_exports_pii': 'Blocca le esportazioni con mascheramento PII per impostazione predefinita.',
  'company_profile.logo': 'Logo',
  'company_profile.cover_image': 'Immagine di Copertina',
  'company_profile.plan_tier': 'Livello Piano',
  'company_profile.plan_tier_hint': 'Gestito dall\'admin. Contattaci per modifiche al piano.',
  'company_profile.commission_rate': 'Tasso di Commissione',
  'company_profile.decimal_example': 'Decimale (es. 0.12 per 12%)',
  'company_profile.readonly_admin': 'Solo admin può modificare',
  'company_profile.effective_platform_fee': 'Commissione piattaforma effettiva',
  'company_profile.effective_default': 'Non impostata a livello vendor – si applicano i valori di default',
  'company_profile.company_name': 'Nome Azienda',
  'company_profile.email': 'Email',
  'company_profile.description': 'Descrizione',
  'company_profile.address': 'Indirizzo',
  'company_profile.city': 'Città',
  'company_profile.postal_code': 'CAP',
  'company_profile.phone': 'Telefono',
  'company_profile.tax_id': 'Codice fiscale',
  'company_profile.legal_name': 'Ragione sociale (se diversa)',
  'company_profile.vat_number': 'Partita IVA',
  'company_profile.sdi_code': 'Codice SDI',
  'company_profile.pec_email': 'Email PEC',
  'company_profile.website_optional': 'Sito web (opzionale)',
  'company_profile.website_url': 'URL sito web',
  'company_profile.facebook': 'Facebook',
  'company_profile.linkedin': 'LinkedIn',
  'company_profile.instagram': 'Instagram',
  'company_profile.whatsapp': 'WhatsApp',
  'company_profile.update_company_btn': 'Aggiorna informazioni azienda',
  'company_profile.placeholder.legal_name': 'Es. FLOWJESOLO SRL',
  'company_profile.placeholder.vat': 'ITxxxxxxxxxxx',
  'company_profile.placeholder.sdi': '7 caratteri',
  'company_profile.placeholder.pec': 'nome@pec.it',
  'company_profile.services.title': 'I tuoi servizi',
  'company_profile.services.subtitle': 'Attiva, disattiva o elimina i servizi. Per modificare prezzi, regole o modalità di prenotazione, apri il configuratore servizi sulla dashboard.',
  'company_profile.services.create_new': 'Crea nuovo servizio',
  'company_profile.services.empty_title': 'Nessun servizio ancora',
  'company_profile.services.empty_help': 'Aggiungi il tuo primo servizio dal configuratore sulla dashboard.',
  'company_profile.services.status_active': 'Attivo',
  'company_profile.services.status_inactive': 'Inattivo',
  'company_profile.services.deactivate': 'Disattiva',
  'company_profile.services.activate': 'Attiva',
  'company_profile.services.edit': 'Modifica',
  'company_profile.services.delete': 'Elimina',
  'company_profile.security.title': 'Sicurezza',
  'company_profile.security.desc': 'Gestisci 2FA e password per l\'account che controlla questa azienda.',
  'company_profile.security.password': 'Cambia password',
  'company_profile.security.password_desc': 'Ti inviamo un\'email per reimpostare la password.',
  'company_profile.security.password_btn': 'Cambia password',
  'company_profile.security.2fa': 'Autenticazione a due fattori',
  'company_profile.security.2fa_desc': 'Aggiungi un ulteriore livello di sicurezza con un\'app Authenticator.',
  'company_profile.toast.verification_required': 'Verifica richiesta',
  'company_profile.toast.verification_required_desc': 'Per continuare, conferma con il codice 2FA.',
  'company_profile.toast.error': 'Errore',
  'company_profile.toast.export_ready': 'Esportazione pronta',
  'company_profile.toast.export_ready_desc': 'JSON scaricato.',
  'company_profile.toast.export_failed': 'Esportazione non riuscita',
  'company_profile.toast.account_deleted': 'Account eliminato',
  'company_profile.toast.account_deleted_desc': 'Il tuo account è stato anonimizzato.',
  'company_profile.toast.delete_failed': 'Eliminazione non riuscita',
  'company_profile.toast.updated': 'Azienda aggiornata',
  'company_profile.toast.updated_desc': 'Informazioni azienda aggiornate con successo.',
  'company_profile.toast.image_uploaded': 'Immagine caricata',
  'company_profile.toast.logo_updated': 'Logo aggiornato con successo.',
  'company_profile.toast.cover_updated': 'Copertina aggiornata con successo.',
  'company_profile.toast.upload_failed': 'Caricamento non riuscito',
  'company_profile.toast.service_deleted': 'Servizio eliminato',
  'company_profile.toast.service_deleted_desc': 'Servizio eliminato con successo.',
  'company_profile.toast.service_toggled': 'Servizio aggiornato',
  'company_profile.toast.service_activated': 'Servizio attivato con successo.',
  'company_profile.toast.service_deactivated': 'Servizio disattivato con successo.',
  'company_profile.toast.saved': 'Salvato',
  'company_profile.toast.save_failed': 'Salvataggio non riuscito',
  'company_profile.toast.email_sent': 'Email inviata',
  'company_profile.toast.email_sent_desc': 'Controlla la casella email per reimpostare la password.',
  'company_profile.validation.company_name': 'Il nome azienda è obbligatorio',
  'company_profile.validation.description': 'La descrizione deve avere almeno 10 caratteri',
  'company_profile.validation.address': 'L\'indirizzo è obbligatorio',
  'company_profile.validation.city': 'La città è obbligatoria',
  'company_profile.validation.postal_code': 'Il CAP è obbligatorio',
  'company_profile.validation.phone': 'Il telefono è obbligatorio',
  'company_profile.validation.email': 'Email valida obbligatoria',
  'company_profile.validation.pec_email': 'Email non valida',
  'company_profile.seo.title': 'Profilo azienda | Halomora',
  'vendor.welcome': 'Benvenuto',
  'vendor.manage': 'Gestisci le prenotazioni e monitora le performance',
  'vendor.settings': 'Impostazioni',
  'vendor.add_service': 'Aggiungi servizio',
  'vendor.google.reconnect_title': 'Ricollega Google Calendar',
  'vendor.google.reconnect_desc': 'La connessione a Google Calendar è scaduta. Ricollega per mantenere le prenotazioni sincronizzate.',
  'vendor.google.reconnect': 'Ricollega Google Calendar',
  'vendor.kpi.total_earnings': 'Incassi totali',
  'vendor.kpi.total_due_halomora': 'Saldo dovuto ad Halomora',
  'vendor.kpi.pending_settle': 'Da saldare (contanti)',
  'vendor.kpi.commission_invoices': 'Commissione prenotazioni a fattura',
  'vendor.kpi.no_pending': 'Nessun importo in sospeso',
  'vendor.kpi.from_completed': 'Da {{count}} prenotazioni completate',
  'vendor.kpi.completed_short': '{{count}} completate',
  'vendor.kpi.total_bookings': 'Prenotazioni totali',
  'vendor.kpi.avg_rating': 'Valutazione media',
  'vendor.kpi.from_reviews': 'Da {{count}} recensioni',
  'vendor.kpi.settle_balance': 'Regola saldo',
  'vendor.tabs.recurring': 'Ricorrenti',
  'vendor.tabs.invoices': 'Fatture e pagamenti',
  'vendor.no_bookings': 'Nessuna prenotazione',
  'vendor.no_bookings_desc': 'Le prenotazioni appariranno qui non appena i clienti inizieranno a prenotare i tuoi servizi.',
  'vendor.fees.platform': 'Commissione piattaforma (Halomora)',
  'vendor.fees.customer': 'Componente fee cliente',
  'vendor.fees.processor': 'Costi pagamento',
  'vendor.fees.payout': 'Netto stimato vendor',
  'vendor.fees.incl_fee': 'incl. {{amount}} fee',
  'vendor.bookings.recent_title': 'Prenotazioni recenti',
  'vendor.bookings.recent_desc': 'Gestisci le prenotazioni imminenti e recenti',
  'vendor.bookings.recurring_badge': 'Ricorrente',
  'vendor.dashboard.loading': 'Caricamento...',
  'vendor.dashboard.not_found': 'Azienda non trovata',
  'vendor.dashboard.need_help': 'Serve aiuto?',
  'vendor.dashboard.download_statement': 'Scarica estratto conto',
  'vendor.dashboard.export_failed': 'Esportazione non riuscita',
  'vendor.dashboard.payments_blocked_title': 'Pagamenti temporaneamente bloccati',
  'vendor.dashboard.payments_blocked_desc': 'Il tuo account è temporaneamente in hold a causa di un tasso di dispute elevato negli ultimi 30 giorni ({{rate}}%). Completa la gestione delle dispute per riabilitare i pagamenti.',
  'vendor.dashboard.stripe_required_title': 'Stripe onboarding richiesto',
  'vendor.dashboard.stripe_required_desc': 'Collega Stripe per abilitare pagamenti carta e payout solo quando l\'account è davvero READY. Requisiti aperti: {{reqs}}',
  'vendor.dashboard.connect_stripe': 'Collega Stripe',
  'vendor.dashboard.refresh_status': 'Aggiorna stato',
  'vendor.dashboard.stripe_onboarding': 'Onboarding Stripe',
  'vendor.dashboard.stripe_dashboard': 'Dashboard Stripe',
  'vendor.dashboard.payout_terms_title': 'Accettazione pagamenti e payout',
  'vendor.dashboard.payout_terms_1': 'Accetto che Halomora possa incassare dal cliente per mio conto tramite Stripe Connect e trattenga le fee applicabili prima del payout.',
  'vendor.dashboard.payout_terms_2': 'Accetto che restano a mio carico obblighi fiscali, fatturazione del servizio, KYC e conto bancario di payout.',
  'vendor.dashboard.payout_terms_3': 'Accetto che chargeback, refund e contestazioni possano ridurre o ritardare i payout.',
  'vendor.dashboard.payout_terms_4_prefix': 'Ho letto e accetto anche il',
  'vendor.dashboard.vendor_agreement': 'Vendor Agreement',
  'vendor.dashboard.save_failed': 'Salvataggio non riuscito',
  'vendor.dashboard.seo.title': 'Dashboard azienda | Halomora',
  'vendor.toast.session_unavailable': 'Sessione non disponibile',
  'vendor.toast.session_relogin': 'Esci e accedi di nuovo, poi riprova.',
  'vendor.toast.stripe': 'Stripe',
  'vendor.toast.error': 'Errore',
  'vendor.toast.status_updated': 'Stato aggiornato',
  'vendor.toast.reason_required': 'Motivo obbligatorio',
  'vendor.toast.cancel_reason': 'Inserisci il motivo della cancellazione.',
  'vendor.toast.reschedule_reason': 'Inserisci il motivo per la riprogrammazione.',
  'vendor.toast.cancelled': 'Cancellato',
  'vendor.toast.cancel_failed': 'Impossibile cancellare',
  'vendor.toast.rescheduled': 'Riprogrammato',
  'vendor.toast.balance': 'Saldo',
  'vendor.toast.balance_amount': 'Importo da saldare: {{amount}}',
  'vendor.toast.no_balance': 'Nessun importo da saldare',
  'vendor.toast.settle_failed': 'Saldo non riuscito',
  'vendor.toast.verification_required': 'Verifica richiesta',
  'vendor.toast.verification_2fa': 'Per continuare, conferma con il codice 2FA.',
  'vendor.toast.calendar_connected': 'Calendario collegato',
  'vendor.toast.calendar_failed': 'Collegamento calendario non riuscito',
  'vendor.toast.field_set': '{{field}} impostato',
  'vendor.toast.timestamp_failed': 'Impossibile aggiornare il timestamp',
  'vendor.toast.incident_reported': 'Incidente segnalato',
  'vendor.toast.incident_failed': 'Impossibile segnalare l\'incidente',
  'vendor.toast.incident_type_missing': 'Tipo incidente mancante',
  'vendor.toast.incident_seed': 'Inserisci incident_types con questo codice',
  'vendor.services.back_to_profile': 'Torna al profilo',
  'vendor.services.existing_title': 'I tuoi servizi',
  'vendor.services.existing_desc': 'Modifica un servizio esistente per aggiornare prezzi, regole e la tab Modalità prenotazione (SLA, urgent, lead time).',
  'vendor.services.updated_desc': 'Le modifiche (incl. modalità prenotazione) sono state salvate.',
  'vendor.services.none': 'Nessun servizio ancora.',
  'vendor.services.cancel_edit': 'Annulla modifica',
  'vendor.services.edit': 'Modifica',
  'vendor.services.editing_label': 'Modifica servizio',
  'vendor.services.updated_title': 'Servizio aggiornato',
  'vendor.services.update_failed': 'Aggiornamento non riuscito',
  'vendor.services.create_new': 'Crea un nuovo servizio',
  'vendor.services.created_title': 'Servizio creato',
  'vendor.services.created_desc': 'Nuovo servizio aggiunto con successo.',
  'vendor.services.create_failed': 'Creazione non riuscita',
  'vendor.offers.title': 'Offerte stagionali',
  'vendor.offers.desc': 'Rimuovi le offerte che non vuoi più mostrare',
  'vendor.offers.none': 'Nessuna offerta stagionale ancora.',
  'vendor.offers.status_active': 'Attivo',
  'vendor.offers.status_inactive': 'Inattivo',
  'vendor.offers.delete_confirm': 'Eliminare questa offerta?',
  'vendor.offers.load_failed': 'Caricamento non riuscito',
  'vendor.offers.load_failed_desc': 'Impossibile caricare le offerte',
  'vendor.offers.delete_failed': 'Eliminazione non riuscita',
  'vendor.offers.published_title': 'Offerta pubblicata',
  'vendor.offers.published_desc': 'La tua offerta stagionale è attiva',
  'vendor.pricing.rule_saved': 'Regola prezzi salvata',
  'vendor.pricing.rule_saved_desc': 'Regola prezzi salvata con successo',
  'vendor.pricing.estimate_title': 'Preventivo generato',
  'vendor.pricing.estimate_desc': 'Fascia prezzo: {{min}} - {{max}}',
  'vendor.analytics.marketing': 'Analytics marketing',
  'vendor.analytics.advanced': 'Analytics avanzate',
  'vendor.analytics.coming_soon_title': 'Analytics avanzate',
  'vendor.analytics.coming_soon_desc': 'Le metriche avanzate, gli insights AI e i report personalizzati saranno disponibili a breve. Stiamo finalizzando il rilascio.',
  'vendor.analytics.pro_title': 'Analytics avanzate',
  'vendor.analytics.pro_desc': 'Sblocca insights dettagliati, metriche avanzate e raccomandazioni AI con il piano PRO per ottimizzare la tua attività.',
  'vendor.ops.close': 'Chiudi',
  'vendor.ops.booking': 'Prenotazione',
  'vendor.ops.delete_photo_confirm': 'Sei sicuro di voler eliminare questa foto?',
  'vendor.ops.photo_deleted': 'Foto eliminata',
  'vendor.ops.delete_failed': 'Eliminazione fallita',
  'vendor.ops.delete_failed_desc': 'Errore durante l\'eliminazione',
  'vendor.toast.session_expired': 'Sessione scaduta o non valida. Esci e accedi di nuovo, poi riprova.',
  'vendor.toast.stripe_onboard_failed': 'Impossibile avviare onboarding Stripe',
  'vendor.toast.stripe_dashboard_failed': 'Impossibile aprire dashboard Stripe',
  'vendor.toast.stripe_onboard_link_unavailable': 'Link onboarding non disponibile',
  'vendor.toast.stripe_dashboard_link_unavailable': 'Link dashboard non disponibile',
  'vendor.toast.api_mode': 'modalità API: {{mode}}',
  'vendor.toast.photo_uploaded': 'Foto caricata',
  'vendor.toast.upload_failed': 'Upload fallito',
  'vendor.toast.metrics_saved': 'Metriche salvate',
  'vendor.toast.metrics_save_failed': 'Impossibile salvare le metriche',
  'vendor.toast.portal_open_failed': 'Impossibile aprire il portale',
  'vendor.toast.checkout_start_failed': 'Impossibile avviare il checkout',
  'vendor.toast.checkout_unavailable': 'Checkout non disponibile',
  'vendor.toast.admin_plan_title': 'Piano gestito dall\'admin',
  'vendor.toast.stripe_portal_title': 'Portale Stripe',
  'vendor.toast.missing_data': 'Dati mancanti',
  'vendor.toast.upgrade_pro_title': 'Passa a PRO',
  'vendor.toast.upgrade_pro_desc': 'Contatta il supporto per passare al piano PRO',
  'vendor.toast.contact_support_title': 'Contatta il supporto',
  'vendor.toast.contact_support_desc': 'Contatta il nostro team per maggiori informazioni',
  'vendor.toast.photos_uploaded': 'Foto caricate',
  'vendor.b2b.title': 'Il mio piano',
  'vendor.b2b.desc': 'Piano PRO, SCALE o gestione su misura (ULTRA)',
  'vendor.b2b.plan_label': 'Piano {{plan}}',
  'vendor.b2b.active': 'Attivo',
  'vendor.b2b.until': 'fino a: {{date}}',
  'vendor.b2b.renew': 'Rinnovo: {{date}}',
  'vendor.b2b.manage': 'Gestisci abbonamento',
  'vendor.b2b.admin_assigned': 'Piano assegnato dall\'amministrazione. Per modifiche contatta il supporto.',
  'vendor.b2b.no_plan': 'Nessun piano a pagamento attivo. Sottoscrivi PRO o SCALE per Google Ads, analytics e supporto dedicato.',
  'vendor.b2b.subscribe_pro': 'Sottoscrivi PRO (99 €/mese)',
  'vendor.b2b.subscribe_scale': 'Sottoscrivi SCALE (299 €/mese)',
  'vendor.b2b.upgrade_scale': 'Passa a SCALE (299 €/mese)',
  'vendor.b2b.ultra_quote': 'ULTRA su preventivo →',
  'vendor.b2b.checkout_scale_hint': 'Se hai già un abbonamento Stripe, prova dal portale o contatta il supporto per passare a SCALE.',
  'vendor.drawer.reschedule_title': 'Riprogramma prenotazione',
  'vendor.drawer.reschedule_desc': 'Specifica un motivo e conferma la nuova data/ora.',
  'vendor.drawer.new_date': 'Nuova data',
  'vendor.drawer.start_time': 'Ora di inizio',
  'vendor.drawer.reschedule_reason': 'Motivo riprogrammazione',
  'vendor.drawer.cancel_title': 'Annulla prenotazione',
  'vendor.drawer.cancel_desc': 'Specifica un motivo per l\'annullamento. Prima di confermare, vedi la stima rimborso secondo policy.',
  'vendor.drawer.refund_estimate': 'Stima rimborso cliente',
  'vendor.drawer.within_48h': 'Entro 48h',
  'vendor.drawer.over_48h': 'Oltre 48h',
  'vendor.drawer.total': 'Totale',
  'vendor.drawer.fee_retained': 'Fee trattenuta',
  'vendor.drawer.refund_estimated': 'Rimborso stimato',
  'vendor.drawer.hours_until': 'Circa {{hours}}h all\'inizio del servizio.',
  'vendor.drawer.cancel_reason': 'Motivo cancellazione',
  'vendor.drawer.reason_required_ph': 'Motivo (obbligatorio)',
  'vendor.drawer.confirm': 'Conferma',
  'vendor.drawer.confirm_cancel': 'Conferma annullamento',
  'vendor.drawer.cancel_btn': 'Annulla',
  'vendor.analytics.pro_feature_1': 'Analytics avanzate in tempo reale',
  'vendor.analytics.pro_feature_2': 'AI insights e raccomandazioni',
  'vendor.analytics.pro_feature_3': 'Segmentazione clienti avanzata',
  'vendor.analytics.pro_feature_4': 'Analisi geografica e temporale',
  'vendor.analytics.pro_feature_5': 'Report personalizzati',
  'vendor.analytics.pro_plan': 'Piano PRO',
  'vendor.analytics.upgrade_btn': 'Passa a PRO',
  'vendor.analytics.contact_btn': 'Contatta il supporto',
  'vendor.ops.timestamps': 'Timestamp',
  'vendor.ops.assigned': 'Assegnato',
  'vendor.ops.depart': 'Partenza',
  'vendor.ops.arrive': 'Arrivo',
  'vendor.ops.start_at': 'Inizio',
  'vendor.ops.finish': 'Fine',
  'vendor.ops.metrics': 'Metriche',
  'vendor.ops.labor_est': 'Manodopera stim. (min)',
  'vendor.ops.labor_actual': 'Manodopera effettiva (min)',
  'vendor.ops.travel': 'Viaggio (min)',
  'vendor.ops.materials': 'Materiali (€)',
  'vendor.ops.save': 'Salva',
  'vendor.ops.checklist': 'Checklist',
  'vendor.ops.refresh': 'Aggiorna',
  'vendor.ops.item': 'Voce',
  'vendor.ops.required': 'Obbligatorio',
  'vendor.ops.add_item': 'Aggiungi voce',
  'vendor.ops.required_tag': '(obbligatorio)',
  'vendor.ops.no_items': 'Nessuna voce ancora.',
  'vendor.ops.incident': 'Incidente',
  'vendor.ops.incident_placeholder': 'Seleziona tipo incidente...',
  'vendor.ops.incident_details': 'Dettagli aggiuntivi (opzionale)',
  'vendor.ops.report_incident': 'Segnala incidente',
  'vendor.ops.photo': 'Foto',
  'vendor.ops.upload_photo': 'Carica foto',
  'vendor.ops.loading': 'Caricamento…',
  'vendor.ops.no_preview': 'Nessuna anteprima',
  'vendor.ops.no_photos': 'Nessuna foto ancora.',
  'vendor.ops.delete_photo_title': 'Elimina foto',
  'vendor.ops.photo_type': 'Tipo foto',
  'vendor.ops.select_files': 'Seleziona file',
  'vendor.ops.files_selected': '{{count}} file selezionati',
  'vendor.ops.uploading': 'Caricamento…',
  'vendor.ops.upload': 'Carica',
  'vendor.ops.photo_prompt': 'Tipo foto: pre | post | evidence',
  'vendor.inbox.title': 'Inbox prenotazioni',
  'vendor.inbox.immediate': 'Immediata',
  'vendor.inbox.request': 'Richiesta',
  'vendor.inbox.sla_expired': 'SLA scaduto — gestisci o attendi timeout',
  'vendor.inbox.sla_remaining': '{{time}} rimanenti',
  'vendor.inbox.filter_pending': 'da approvare (vendor)',
  'vendor.inbox.filter_urgent': 'solo urgenti',
  'vendor.inbox.filter_confirmed': 'confermati',
  'vendor.inbox.empty': 'Nessuna prenotazione in questa vista.',
  'vendor.inbox.total': 'Totale:',
  'vendor.inbox.accept': 'Accetta',
  'vendor.inbox.reject': 'Rifiuta',
  'vendor.inbox.view': 'Vedi',
  'vendor.inbox.tab_action': 'Azione richiesta',
  'vendor.inbox.tab_urgent': 'Urgenti',
  'vendor.inbox.tab_confirmed': 'Confermati',
  'vendor.inbox.tab_all': 'Tutte',
  'vendor.common.delete': 'Elimina',
  'vendor.toast.load_failed': 'Impossibile caricare i dati',
  'vendor.toast.calendar_refreshed': 'Stato calendario aggiornato',
  'vendor.toast.calendar_active': 'Google Calendar è collegato e attivo',
  'vendor.toast.calendar_reconnect': 'Google Calendar richiede riconnessione',
  'vendor.toast.calendar_refresh_failed': 'Impossibile aggiornare lo stato del calendario',
  'vendor.toast.checklist_added': 'Voce checklist aggiunta',
  'vendor.toast.checklist_failed': 'Impossibile aggiungere la voce',
  'vendor.toast.not_signed_in': 'Accesso non effettuato',
  'vendor.toast.settle_api_failed': 'Saldo non riuscito',
  'vendor.notify.rescheduled_title': 'Prenotazione riprogrammata',
  'vendor.notify.rescheduled_body': 'La tua prenotazione è stata spostata al {{date}} {{time}}',
  'vendor.availability.saved_title': 'Disponibilità salvata',
  'vendor.availability.saved_desc': 'Le tue disponibilità sono state aggiornate',
  'vendor.quotes.sent_title': 'Preventivo inviato',
  'vendor.quotes.sent_desc': 'Preventivo inviato con successo',
  'vendor.quotes.status_updated': 'Stato aggiornato',
  'vendor.quotes.status_changed_desc': 'Stato richiesta preventivo cambiato in {{status}}',
  'vendor.inbox.urgent_badge': 'Urgente',
  'vendor.inbox.sla_vendor_response': 'Risposta vendor: ~{{mins}} min rimanenti · scadenza {{deadline}}',
  'vendor.inbox.filter_title': 'Filtri prenotazioni',
  'vendor.inbox.filter_desc': 'Filtra e ordina le richieste di prenotazione',
  'vendor.inbox.bookings_title': 'Prenotazioni',
  'vendor.inbox.view_label': 'Vista:',
  'vendor.inbox.tab_pending_short': 'Da approvare',
  'vendor.inbox.filter_all': 'tutti',
  'vendor.inbox.details': 'Dettagli',
  'vendor.invoices.completed_title': 'Lavori completati con richiesta fattura',
  'vendor.invoices.completed_desc': 'Elenco dei servizi svolti che hanno richiesto fattura. Esporta in CSV per inserirli nei tuoi sistemi di fatturazione.',
  'vendor.invoices.completed_empty': 'Nessun lavoro completato con richiesta fattura.',
  'vendor.invoices.bookings_count': '{{count}} prenotazioni',
  'vendor.invoices.export_csv': 'Esporta CSV',
  'vendor.invoices.export_done': 'Export completato',
  'vendor.invoices.export_done_desc': 'File CSV scaricato.',
  'vendor.invoices.col_date': 'Data',
  'vendor.invoices.col_customer': 'Cliente',
  'vendor.invoices.col_service': 'Servizio',
  'vendor.invoices.col_amount': 'Importo',
  'vendor.invoices.showing_first': 'Mostrati i primi 20. Usa Esporta CSV per l\'elenco completo.',
  'vendor.invoices.unpaid_title': 'Pagamenti non ancora ricevuti',
  'vendor.invoices.unpaid_desc': 'Prenotazioni completate (contanti o a fattura) per le quali non hai ancora segnato il pagamento ricevuto.',
  'vendor.invoices.unpaid_empty': 'Nessuna prenotazione in attesa di pagamento.',
  'vendor.invoices.mark_paid': 'Segna come pagato',
  'vendor.invoices.marked_paid': 'Segnato come pagato',
  'vendor.invoices.payment_invoice': 'Fattura',
  'vendor.invoices.payment_cash': 'Contanti',
  'vendor.invoices.to_emit_title': 'Fatture da emettere',
  'vendor.invoices.to_emit_desc': 'Prenotazioni con richiesta fattura per le quali non hai ancora segnato l\'emissione. Filtra per cliente e periodo.',
  'vendor.invoices.date_from': 'Da data',
  'vendor.invoices.date_to': 'A data',
  'vendor.invoices.customer_search': 'Cliente (email/nome)',
  'vendor.invoices.search_ph': 'Cerca cliente',
  'vendor.invoices.to_emit_empty': 'Nessuna fattura da emettere con i filtri selezionati.',
  'vendor.invoices.mark_emitted': 'Segna fattura emessa',
  'vendor.invoices.marked_emitted': 'Fattura segnata come emessa',
  'vendor.invoices.op_failed': 'Operazione non riuscita',
  'availability.not_signed_in': 'Non connesso',
  'availability.sign_in_to_save': 'Accedi per salvare la disponibilità',
  'availability.no_company': 'Nessuna azienda trovata',
  'availability.complete_onboarding': 'Completa prima l\'onboarding',
  'availability.save_failed': 'Salvataggio fallito',
  'availability.saved': 'Disponibilità salvata',
  'availability.changes_live': 'Le tue modifiche sono attive',
  'availability.title': 'Disponibilità (prossime 2 settimane)',
  'availability.description': 'Imposta quanti lavori puoi accettare per ogni fascia oraria. Non devi inserire tutti i turni dei dipendenti: qui devi solo indicare la capacità reale che vuoi vendere su Halomora.',
  'availability.capacity_jobs': 'Lavori accettabili',
  'availability.blocked_slot': 'Chiudi fascia',
  'availability.save': 'Salva disponibilità',
  'availability.how_capacity_works': 'Come funziona la capacità su Halomora',
  'availability.capacity_intro_1': 'La capacità non significa "quanti dipendenti hai". Significa quanti lavori puoi accettare bene in quella fascia oraria.',
  'availability.capacity_intro_2': 'Ragiona così: quante squadre sono davvero disponibili, quante ore utili hanno e quanti lavori riescono a chiudere senza andare in difficoltà.',
  'availability.capacity_rule': 'Regola pratica: meglio pubblicare una capacità prudente e lavorare bene, piuttosto che accettare troppo e andare in crisi.',
  'availability.mode_simple': 'Modalità semplice',
  'availability.mode_advanced': 'Dettaglio completo',
  'availability.assisted_title': '0. Calcolo assistito della capacità (facoltativo)',
  'availability.assisted_desc': 'Se vuoi partire da una base ragionata, inserisci quante squadre hai di solito disponibili, quanti lavori chiude bene una squadra e il margine di sicurezza che vuoi tenere.',
  'availability.teams_available': 'Squadre disponibili di solito',
  'availability.jobs_per_team': 'Lavori che una squadra chiude bene',
  'availability.avg_yield': 'Resa media',
  'availability.safety_margin': 'Margine di sicurezza',
  'availability.safety_margin_pct': 'Percentuale che vuoi tenere libera',
  'availability.suggested_capacity': 'Capacità consigliata',
  'availability.close_slot': 'Chiudi fascia',
  'availability.suggested_n': 'Capacità suggerita: {{n}}',
  'availability.suggested_blocked': 'Con queste informazioni, qui conviene non accettare nuovi lavori.',
  'availability.suggested_jobs': 'Con le squadre indicate e il margine scelto, puoi partire da {{n}} {{jobs}}.',
  'availability.job': 'lavoro',
  'availability.jobs': 'lavori',
  'availability.apply_to_weekdays': 'Applica questa base ai giorni standard',
  'availability.custom_days_unchanged': 'I giorni già personalizzati non cambiano. Tutti gli altri adottano questa base.',
  'availability.configure_14': '1. Configura i prossimi 14 giorni',
  'availability.configure_14_desc': 'Apri e regola solo i giorni che vuoi cambiare. Se una configurazione vale di solito, puoi trasformarla subito nella regola standard del relativo giorno della settimana.',
  'availability.follow_standard': '{{n}} giorni seguono la base standard',
  'availability.custom_days': '{{n}} giorno/i personalizzato/i',
  'availability.exception': 'Eccezione',
  'availability.standard_base': 'Base standard',
  'availability.open_details': 'Apri dettagli',
  'availability.close_details': 'Chiudi dettagli',
  'availability.slot_closed': 'Fascia chiusa',
  'availability.jobs_available': '{{n}} lavori disponibili',
  'availability.reopen_slot': 'Riapri fascia',
  'availability.slot_no_jobs': 'Questa fascia non riceve nuovi lavori. Riaprila quando vuoi rimetterla in vendita.',
  'availability.use_as_weekday_rule': 'Usa questa configurazione come regola per tutti i {{weekday}}',
  'availability.reset_weekday': 'Ripristina base {{weekday}}',
  'availability.weekday_rule_hint': 'Se questo giorno rappresenta il tuo assetto abituale, applica la stessa configurazione a tutti i {{weekday}}.',
  'availability.advanced_mode': 'Modalità avanzata',
  'availability.advanced_desc': 'Qui puoi intervenire giorno per giorno su tutte le prossime 2 settimane. Usala solo se hai bisogno di un controllo più granulare.',
  'availability.no_jobs_yet': 'Nessun lavoro per ora',
  'offers.not_signed_in': 'Non connesso',
  'offers.sign_in_to_publish': 'Accedi per pubblicare offerte',
  'offers.no_company': 'Nessuna azienda trovata',
  'offers.complete_onboarding': 'Completa prima l\'onboarding',
  'offers.publish_failed': 'Pubblicazione fallita',
  'offers.published': 'Offerta pubblicata',
  'offers.live': 'La tua offerta stagionale è attiva',
  'offers.title': 'Offerta stagionale',
  'offers.description': 'Crea un\'offerta promozionale limitata nel tempo',
  'offers.placeholder.name': 'Nome offerta (es. Pulizia Profonda Primaverile)',
  'offers.placeholder.service': 'Seleziona un servizio',
  'offers.fields.start_date': 'Data inizio',
  'offers.fields.end_date': 'Data fine',
  'offers.fields.discount': 'Sconto (%)',
  'offers.fields.active': 'Attivo',
  'offers.publish': 'Pubblica offerta',
  'estimator.title': 'Stimatore prezzi AI',
  'estimator.description': 'Imposta regole di prezzo intelligenti che si adattano automaticamente in base alla complessità del servizio, area e urgenza',
  'estimator.tabs.setup_rules': 'Imposta regole',
  'estimator.tabs.test_estimator': 'Testa stimatore',
  'estimator.tabs.ai_insights': 'Insights AI',
  'service.templates.basic_cleaning': 'Pulizia base',
  'service.templates.basic_cleaning_desc': 'Servizio di pulizia standard per metro quadrato',
  'service.templates.deep_clean': 'Pulizia profonda',
  'service.templates.deep_clean_desc': 'Servizio di pulizia intensiva con materiali premium',
  'service.templates.garden_maintenance': 'Manutenzione giardino',
  'service.templates.garden_maintenance_desc': 'Manutenzione regolare del giardino e paesaggistica',
  'service.templates.window_cleaning': 'Pulizia vetri',
  'service.templates.window_cleaning_desc': 'Servizio professionale di pulizia vetri',
  'service.templates.carpet_cleaning': 'Pulizia tappeti',
  'service.templates.carpet_cleaning_desc': 'Pulizia profonda tappeti con estrazione a vapore',
  'service.templates.recurring_package': 'Pacchetto ricorrente',
  'service.templates.recurring_package_desc': 'Servizio ricorrente settimanale/mensile con sconto',
  'service.included.dusting': 'Spolveratura',
  'service.included.vacuuming': 'Aspirapolvere',
  'service.included.mopping': 'Lavaggio',
  'service.included.bathroom_cleaning': 'Pulizia bagno',
  'service.included.kitchen_surfaces': 'Superfici cucina',
  'service.benefits.insured_staff': 'Personale assicurato e verificato',
  'service.benefits.eco_products': 'Prodotti ecologici',
  'service.benefits.flexible_scheduling': 'Orari flessibili',
  'service.benefits.satisfaction_guarantee': 'Garanzia di soddisfazione',
  'service.template_applied': 'Modello applicato',
  'service.template_applied_desc': 'Il modello {{name}} è stato applicato al tuo servizio.',
  'service.pricing.bounds_invalid_title': 'Limiti prezzo non validi',
  'service.pricing.bounds_invalid': 'MIN non può essere maggiore di MAX',
  'service.success': 'Successo',
  'service.updated': 'Servizio aggiornato con successo!',
  'service.created': 'Servizio creato con successo!',
  'service.builder.title': 'Costruttore servizi dinamico',
  'service.builder.description': 'Crea servizi con opzioni di prezzo flessibili e regole personalizzate',
  'service.tabs.basic_info': 'Info base',
  'service.tabs.pricing_rules': 'Regole prezzo',
  'service.tabs.booking_modes': 'Modalità prenotazione',
  'service.tabs.templates': 'Modelli',
  'service.tabs.includes_benefits': 'Include e vantaggi',
  'service.fields.name': 'Nome servizio',
  'service.placeholders.name': 'es. Pulizia casa premium',
  'service.fields.category': 'Categoria',
  'service.placeholders.category': 'Seleziona una categoria',
  'service.fields.description': 'Descrizione',
  'service.placeholders.description': 'Descrivi il tuo servizio in dettaglio...',
  'service.fields.duration': 'Durata (minuti)',
  'service.pricing.modifiers': 'Regole di prezzo (dimensione immobile e tipologie)',
  'service.pricing.modifiers_help': 'Permetti che il prezzo finale cambi in base alle scelte del cliente in fase di booking (metratura, tipologia). Se non attivi questa opzione, il prezzo resta fisso.',
  'service.pricing.disabled_explain': 'Le regole di prezzo sono disattivate per questo servizio. Il cliente vedrà direttamente il prezzo base.',
  'service.pricing.bounds': 'Limiti sul prezzo finale (MIN / MAX EUR)',
  'service.pricing.bounds_help': 'Imposta i limiti entro cui il prezzo finale può variare dopo le regole.',
  'service.pricing.bounds_min': 'MIN EUR',
  'service.pricing.bounds_min_placeholder': 'es. 80',
  'service.pricing.bounds_max': 'MAX EUR',
  'service.pricing.bounds_max_placeholder': 'es. 250',
  'service.pricing.sqm': 'Metratura',
  'service.pricing.sqm_unit_hint': 'Tutti i valori in metri quadrati (m²). Scale è un moltiplicatore adimensionale.',
  'service.pricing.sqm_min': 'Min (m²)',
  'service.pricing.sqm_max': 'Max (m²)',
  'service.pricing.sqm_step': 'Step (m²)',
  'service.pricing.sqm_tiers_help': 'Configura scaglioni (range m² → % aumento).',
  'service.pricing.tiers': 'Scaglioni',
  'service.pricing.add_tier': 'Aggiungi scaglione',
  'service.pricing.no_tiers': 'Nessuno scaglione: aggiungine almeno uno.',
  'service.pricing.types': 'Tipologie (solo pulizie)',
  'service.pricing.custom': 'Opzioni personalizzate',
  'service.pricing.add': 'Aggiungi',
  'service.pricing.preview': 'Preview (esempio 130m², urgente):',
  'service.booking_policy.title': 'Lead time, approvazione vendor e prezzo urgente',
  'service.booking_policy.help': 'Il sistema calcola automaticamente instant / richiesta / urgente in base a data e ora del servizio (fuso Europe/Rome). Qui abiliti le fasce e gli SLA.',
  'service.booking_policy.instant': 'Immediata (≥ 48h)',
  'service.booking_policy.enabled': 'Abilitata',
  'service.booking_policy.min_notice_h': 'Anticipo minimo (ore)',
  'service.booking_policy.request': 'Richiesta vendor (24–48h)',
  'service.booking_policy.sla_min': 'SLA risposta vendor (min)',
  'service.booking_policy.urgent': 'Urgente (12-24h)',
  'service.booking_policy.urgent_explain': 'Le prenotazioni urgenti possono avere una maggiorazione mostrata chiaramente al cliente.',
  'service.booking_policy.max_notice_h': 'Anticipo max (ore)',
  'service.booking_policy.urgent_mult': 'Moltiplicatore prezzo urgente',
  'service.booking_policy.cutoff_note': 'Stesso giorno: prenotazioni consentite solo prima delle 08:00 (Europe/Rome), come da policy server.',
  'vendor.bulk.loading': 'Caricamento bulk orders…',
  'vendor.bulk.empty': 'Nessun bulk order ancora.',
  'vendor.bulk.no_rows': 'Nessuna riga con questi filtri.',
  'vendor.tracker.load_error': 'Errore caricamento tracker',
  'vendor.tracker.error': 'Errore',
  'vendor.tracker.booking_fallback': 'Prenotazione',
  'vendor.tracker.no_data': 'Nessun dato per ora.',
  'vendor.tracker.no_platform_bookings': 'Nessuna prenotazione Halomora nel periodo.',
  'vendor.tracker.no_external': 'Nessun booking esterno con etichetta.',
  'vendor.tracker.no_day_bookings': 'Nessun booking per questo giorno.',
  'vendor.tracker.no_filtered_events': 'Nessun evento corrisponde ai filtri selezionati.',
  'vendor.tracker.no_date': 'Senza data',
  'vendor.tracker.session_expired': 'Sessione scaduta',
  'vendor.tracker.sign_in_again': 'Effettua di nuovo l\'accesso.',
  'vendor.tracker.saved': 'Salvato nel tracker',
  'vendor.tracker.saved_desc': 'Salvato nel tracker. Non finisce nelle prenotazioni piattaforma.',
  'vendor.tracker.none': 'Nessuno',
  'vendor.tracker.saving': 'Salvataggio…',
  'vendor.tracker.update': 'Aggiorna',
  'vendor.tracker.add': 'Aggiungi al tracker',
  'vendor.tracker.import_error': 'Errore in importazione',
  'vendor.tracker.review_save': '2. Rivedi & salva',
  'vendor.recurring.loading': 'Caricamento prenotazioni ricorrenti…',
  'vendor.recurring.empty': 'Nessuna prenotazione ricorrente ancora.',
  'vendor.recurring.title': 'Prenotazioni ricorrenti',
  'vendor.recurring.desc': 'Gestisci serie e occorrenze di prenotazioni',
  'availability.helper.blocked': 'Fascia chiusa: non ricevi nuovi lavori in questo orario.',
  'availability.helper.zero': 'Capacità 0: in questa fascia non stai accettando lavori.',
  'availability.helper.one': 'Capacità 1: puoi accettare bene 1 lavoro in questa fascia.',
  'availability.helper.n': 'Capacità {{capacity}}: puoi accettare bene {{capacity}} lavori in questa fascia.',
  'availability.example_title': 'Esempio semplice',
  'availability.example_line_1': 'Lunedì mattina: 2 squadre disponibili, ognuna chiude 1 turnover bene → capacità 2',
  'availability.example_line_2': 'Lunedì pomeriggio: una squadra è occupata fuori piattaforma, l\'altra ha margine per 1 solo job → capacità 1',
  'vendor.bulk.title': 'Bulk orders',
  'vendor.bulk.beta': 'beta',
  'vendor.bulk.desc': 'Ogni bulk order raggruppa più prenotazioni importate. Apri per vedere righe, finestra e breakdown.',
  'vendor.bulk.go_calendar': 'Vai al calendario',
  'vendor.bulk.scheduler_intro_title': 'AI Turnover Scheduler: segnali già disponibili',
  'vendor.bulk.scheduler_intro_desc': 'Questo pannello sta già raccogliendo i segnali chiave del primo scheduler: finestre strette, interventi non ancora pianificati e batch in scadenza. L\'obiettivo è rendere più leggibile cosa confermare, cosa anticipare e dove serve più copertura.',
  'vendor.bulk.rows': '{{count}} righe',
  'vendor.bulk.total': 'Totale:',
  'vendor.bulk.window': 'Finestra complessiva: {{start}} → {{end}}',
  'vendor.bulk.scheduler_signals': 'Segnali scheduler: {{summary}}',
  'vendor.bulk.services': 'Servizi: {{list}}',
  'vendor.bulk.open': 'Apri',
  'vendor.bulk.sheet_title': 'Bulk order {{id}}',
  'vendor.bulk.sheet_created': 'Creato: {{date}} • Righe: {{count}}',
  'vendor.bulk.filter_status': 'Filtro status',
  'vendor.bulk.filter_all': 'Tutti',
  'vendor.bulk.search': 'Ricerca',
  'vendor.bulk.search_ph': 'Indirizzo o booking #',
  'vendor.bulk.tight_on': 'Finestre strette: ON',
  'vendor.bulk.tight_only': 'Solo finestre strette',
  'vendor.bulk.tip': 'Tip: per assegnare orari velocemente, usa “Vai al calendario” e ripianifica rispettando la finestra.',
  'vendor.bulk.scheduler_summary': 'Scheduler summary',
  'vendor.bulk.confidence': 'Affidabilità {{level}}',
  'vendor.bulk.source_server': 'motore server v1',
  'vendor.bulk.source_fallback': 'fallback locale (motore non raggiungibile)',
  'vendor.bulk.source_local': 'calcolo locale',
  'vendor.bulk.updating': 'aggiornamento in corso…',
  'vendor.bulk.source_label': 'Fonte: {{source}}{{extra}}',
  'vendor.bulk.urgent_badge': 'in scadenza',
  'vendor.bulk.tight_badge': 'finestra ≤ 2h',
  'vendor.bulk.unscheduled_badge': 'da pianificare',
  'vendor.bulk.service_fallback': 'Servizio',
  'vendor.bulk.price': 'Prezzo:',
  'vendor.bulk.window_row': 'Finestra:',
  'vendor.bulk.notes': 'Note:',
  'vendor.bulk.open_booking': 'Apri booking',
  'vendor.bulk.assign_time': 'Assegna orario',
  'availability.slot_closed_short': 'chiusa',
  'availability.slot_summary': '{{label}}: {{status}}',
  'availability.jobs_count': '{{n}} lavori',
  'availability.job_count': '1 lavoro',
  'availability.suggested_blocked_hint': 'Con queste informazioni, qui conviene non accettare nuovi lavori.',
  'availability.suggested_jobs_hint': 'Con le squadre indicate e il margine scelto, puoi partire da {{n}} {{jobs}}.',
  'availability.apply_weekdays': 'Applica questa base ai giorni standard',
  'availability.custom_days_note': 'I giorni già personalizzati non cambiano. Tutti gli altri adottano questa base.',
  'availability.configure_14_title': '1. Configura i prossimi 14 giorni',
  'availability.days_standard': '{{n}} giorni seguono la base standard',
  'availability.days_custom': '{{n}} giorno/i personalizzato/i',
  'availability.slot_closed_label': 'Fascia chiusa',
  'availability.slot_no_jobs_hint': 'Questa fascia non riceve nuovi lavori. Riaprila quando vuoi rimetterla in vendita.',
  'availability.use_weekday_rule': 'Usa questa configurazione come regola per tutti i {{weekday}}',
  'availability.close_slot_hint': 'Se chiudi la fascia, Halomora non la considererà disponibile per nuovi lavori.',
  'availability.weekday.0': 'Domenica',
  'availability.weekday.1': 'Lunedì',
  'availability.weekday.2': 'Martedì',
  'availability.weekday.3': 'Mercoledì',
  'availability.weekday.4': 'Giovedì',
  'availability.weekday.5': 'Venerdì',
  'availability.weekday.6': 'Sabato',
  'availability.load_title': 'Carico attuale prossimi 14 giorni',
  'availability.load_desc': 'Lavori già conteggiati (piattaforma + booking esterni): {{load}} contro una capacità pubblicata totale di {{capacity}}.',
  'availability.over_capacity_days': '{{n}} giorno/i in over-capacity',
  'availability.closed_with_load': '{{n}} giornata/e chiusa/e con lavori',
  'availability.near_limit_days': '{{n}} giorno/i vicini al limite',
  'availability.load_ok': 'Carico sotto controllo',
  'availability.load_footer': 'I booking esterni che hai inserito nel Tracker contano qui solo per te: non vengono mostrati al lato cliente. Se vedi sempre rosso, alza la capacità o chiudi i giorni in cui non vuoi prenotazioni nuove.',
  'availability.v2_title': 'Modello assistito v2 (in arrivo)',
  'availability.v2_badge': 'Prossima release',
  'availability.v2_desc': 'Quando il motore server-side sarà attivo, potrai aggiungere anche assenze, durata media degli interventi e buffer per imprevisti. La capacità suggerita verrà ricalcolata in automatico tenendo conto del carico reale del periodo.',
  'vendor.tracker.title': 'Tracker booking',
  'vendor.tracker.desc': 'Un solo punto per consuntivare i booking della piattaforma e quelli gestiti fuori. Quelli esterni restano locali al tracker, non finiscono nelle prenotazioni Halomora e non generano commissioni.',
  'vendor.tracker.bulk_add': 'Aggiungi in blocco',
  'vendor.tracker.new_external': 'Nuovo booking esterno',
  'vendor.tracker.kpi.total': 'Totale',
  'vendor.tracker.kpi.platform': 'Piattaforma',
  'vendor.tracker.kpi.external': 'Esterni',
  'vendor.tracker.kpi.today': 'Oggi',
  'vendor.tracker.kpi.next7': 'Prossimi 7 gg',
  'vendor.tracker.chart_mix': 'Mix per origine',
  'vendor.tracker.chart_services': 'Top servizi',
  'vendor.tracker.chart_services_desc': 'Su Halomora vediamo i servizi del catalogo; tra gli esterni le tipologie di turnover che hai etichettato tu.',
  'vendor.tracker.tab_halomora': 'Halomora',
  'vendor.tracker.tab_external': 'Esterni',
  'vendor.tracker.scheduler_title': 'AI Turnover Scheduler — sintesi',
  'vendor.tracker.scheduler_desc': 'Calcolato sul tuo carico reale: prenotazioni Halomora + booking esterni che hai inserito qui.',
  'vendor.tracker.confidence': 'Affidabilità {{level}}',
  'vendor.tracker.scheduler_signals': 'Segnali scheduler: {{summary}}',
  'vendor.tracker.privacy_note': 'I booking esterni che inserisci restano privati al tuo profilo: non vengono mostrati al lato demand.',
  'vendor.tracker.source_server': 'motore server v1',
  'vendor.tracker.source_fallback': 'fallback locale (motore non raggiungibile)',
  'vendor.tracker.source_local': 'calcolo locale',
  'vendor.tracker.updating': 'aggiornamento in corso…',
  'vendor.tracker.source_label': 'Fonte: {{source}}{{extra}}',
  'vendor.tracker.urgent_title': 'Da gestire adesso ({{count}}',
  'vendor.tracker.urgent_desc': 'Righe in scadenza entro 24 ore o ancora senza data: mettile a posto prima del resto.',
  'vendor.tracker.badge_platform': 'Piattaforma',
  'vendor.tracker.badge_external': 'Esterno',
  'vendor.tracker.badge_24h': 'finestra entro 24h',
  'vendor.tracker.badge_flexible': 'flessibile, senza data',
  'vendor.tracker.external_booking': 'Booking esterno',
  'vendor.tracker.closes': 'chiude {{date}}',
  'vendor.tracker.plan': 'Pianifica',
  'vendor.tracker.more_rows': '...altre {{n}} righe da gestire. Apri la lista per vederle tutte.',
  'vendor.tracker.tight_title': 'Finestre strette e giornate piene',
  'vendor.tracker.tight_desc': 'Casi in cui pianificare per primi: poco margine sulla finestra utile, oppure più turnover nello stesso giorno.',
  'vendor.tracker.badge_tight': 'finestra ≤ 2h',
  'vendor.tracker.cluster_same_day': 'Cluster same-day turnover:',
  'vendor.tracker.cluster_hint': '— pianifica con margini extra tra checkout e check-in.',
  'vendor.tracker.filters': 'Filtri:',
  'vendor.tracker.filter_all_sources': 'Tutte le origini',
  'vendor.tracker.filter_platform_only': 'Solo piattaforma',
  'vendor.tracker.filter_external_only': 'Solo esterni',
  'vendor.tracker.filter_all_status': 'Tutti gli stati',
  'vendor.tracker.status.planned': 'Pianificato',
  'vendor.tracker.status.pending': 'In attesa (piatt.)',
  'vendor.tracker.status.confirmed': 'Confermato (piatt.)',
  'vendor.tracker.status.in_progress': 'In corso',
  'vendor.tracker.status.completed': 'Completato',
  'vendor.tracker.status.cancelled': 'Annullato',
  'vendor.tracker.legend_over': 'Over-capacity',
  'vendor.tracker.legend_near': 'Vicino al limite',
  'vendor.tracker.tab_calendar': 'Calendario',
  'vendor.tracker.tab_list': 'Elenco',
  'vendor.tracker.tab_todo': 'Da pianificare ({{count}})',
  'vendor.tracker.events': '{{count}} eventi',
  'vendor.tracker.flexible_title': 'Senza data — Flessibili ({{count}})',
  'vendor.tracker.flexible_desc': 'Booking esterni senza nessuna data: il cliente ha chiesto a te quando organizzare la pulizia. Modificali quando hai scelto la finestra o l\'orario.',
  'vendor.tracker.mode_flexible': 'Flessibile',
  'vendor.tracker.delete_confirm': 'Eliminare questo booking dal tracker?',
  'vendor.tracker.deleted': 'Eliminato',
  'vendor.tracker.deleted_desc': 'Booking rimosso dal tracker.',
  'vendor.tracker.delete_failed': 'Impossibile eliminare.',
  'vendor.tracker.retry': 'Riprova.',
  'vendor.tracker.other': 'Altro',
  'vendor.tracker.no_label': 'Senza etichetta',
  'vendor.tracker.unit_booking': 'booking',
  'vendor.tracker.mode.exact': 'Orario esatto',
  'vendor.tracker.mode.window': 'Finestra checkout/check-in',
  'vendor.tracker.mode.date_only': 'Solo giorno',
  'vendor.tracker.mode.flexible': 'Flessibile',
  'vendor.tracker.time.all_day': 'Tutto il giorno',
  'vendor.tracker.edit': 'Modifica',
  'vendor.tracker.delete': 'Elimina',
  'vendor.tracker.range_title': 'Con range — Da fissare al giorno esatto ({{count}})',
  'vendor.tracker.range_desc': 'Booking con un range già dichiarato — finestra checkout/check-in oppure solo giornata. Quando decidi il giorno e l\'ora precisi, apri la riga con Pianifica e convertila in modalità "Orario esatto".',
  'vendor.tracker.range_label': 'Range',
  'vendor.tracker.flexible_pending': 'Flessibile (da pianificare)',
  'vendor.tracker.detail.service': 'Servizio',
  'vendor.tracker.detail.customer': 'Cliente',
  'vendor.tracker.detail.phone': 'Telefono',
  'vendor.tracker.detail.email': 'Email',
  'vendor.tracker.detail.address': 'Indirizzo',
  'vendor.tracker.detail.date': 'Data',
  'vendor.tracker.detail.time': 'Orario',
  'vendor.tracker.detail.amount': 'Importo',
  'vendor.tracker.detail.number': 'Numero',
  'vendor.tracker.detail.notes': 'Note',
  'vendor.tracker.detail.label': 'Etichetta',
  'vendor.tracker.detail.when': 'Quando',
  'vendor.tracker.detail.duration': 'Durata',
  'vendor.tracker.detail.guests': 'Ospiti',
  'vendor.tracker.detail.pets': 'Animali',
  'vendor.tracker.detail.kids': 'Bambini',
  'vendor.tracker.detail.yes': 'Sì',
  'availability.day_load_empty': 'Carico attuale: 0 lavori. Pubblica la capacità per indicare quanti puoi accettare.',
  'availability.load_ok_label': 'Carico ok',
  'availability.load_closed_day': 'Lavori in giornata chiusa',
  'availability.load_near_limit': 'Vicino al limite',
  'availability.load_compact': '{{load}} carico · {{status}}',
  'availability.load_compact_closed': 'chiusa',
  'availability.load_compact_cap': 'cap {{capacity}}',
  'availability.load_current': 'Carico attuale: {{load}}',
  'availability.slot_declared_closed': 'fascia dichiarata chiusa',
  'availability.published_capacity': 'capacità pubblicata: {{capacity}}',
  'availability.v2_absences': 'Assenze previste',
  'availability.v2_absences_ph': 'Es. ferie, malattia',
  'availability.v2_absences_hint': 'Riduce la capacità del giorno coinvolto.',
  'availability.v2_duration': 'Durata media intervento (min)',
  'availability.v2_duration_ph': 'Es. 90',
  'availability.v2_duration_hint': 'Serve a stimare quante chiusure entrano in una fascia.',
  'availability.v2_buffer': 'Buffer per imprevisti',
  'availability.v2_buffer_ph': 'Es. 15 min tra job',
  'availability.v2_buffer_hint': 'Margine tra un turnover e quello successivo.',
  'scheduler.counts_summary': '{{tight}} finestre strette • {{unscheduled}} non pianificati • {{urgent}} in scadenza',
  'scheduler.risk.count': '{{count}} × {{label}}',
  'scheduler.risk.URGENT': 'in scadenza entro 24h',
  'scheduler.risk.TIGHT_WINDOW': 'finestra ≤ 2 ore',
  'scheduler.risk.UNSCHEDULED': 'ancora senza data o orario',
  'scheduler.risk.SAME_DAY_TURNOVER': 'checkout e check-in nello stesso giorno',
  'scheduler.risk.OVER_CAPACITY_DAY': 'giorno in over-capacity',
  'scheduler.risk.NEAR_CAPACITY_DAY': 'giorno vicino alla saturazione',
  'scheduler.risk.CLOSED_DAY_WITH_LOAD': 'giorno dichiarato chiuso ma con lavoro',
  'scheduler.risk.SAME_DAY_TURNOVER_CLUSTER': 'cluster di turnover same-day',
  'scheduler.action.closed_with_load': 'Hai lavoro pianificato in giornate dichiarate chiuse. Aggiorna la disponibilità o sposta i job.',
  'scheduler.action.over_capacity': 'Hai uno o più giorni in over-capacity. Sposta carico, alza la capacità pubblicata o non accettare altro.',
  'scheduler.action.urgent': 'Conferma subito le righe in scadenza o amplia la copertura.',
  'scheduler.action.tight_unscheduled': 'Assegna priorità ai turnover con finestra stretta e pianifica dal calendario.',
  'scheduler.action.unscheduled': 'Distribuisci le righe non ancora pianificate prima di accettare nuovo carico.',
  'scheduler.action.ok': 'Batch sotto controllo: monitora e aggiorna il calendario solo in caso di variazioni.',
  'scheduler.batch.closed': 'Attenzione: in {{count}} {{dates}} utili risultano fasce chiuse o senza capacità pubblicata. Se vuoi coprire questi turnover, aggiorna prima la disponibilità.',
  'scheduler.batch.closed_dates_one': 'data',
  'scheduler.batch.closed_dates_many': 'date',
  'scheduler.batch.low_capacity': 'Hai capacità pubblicata bassa in {{count}} {{dates}} toccate dal batch. Se la tua squadra reale ha più margine, aggiorna Availability prima di pianificare.',
  'scheduler.batch.low_dates_one': 'data toccata dal batch',
  'scheduler.batch.low_dates_many': 'date toccate dal batch',
  'scheduler.confidence.alta': 'Affidabilità alta: lo scheduler ha dati sufficienti per il suggerimento.',
  'scheduler.confidence.media': 'Affidabilità media: alcune righe non hanno orario o capacità pubblicata.',
  'scheduler.confidence.bassa': 'Affidabilità bassa: troppi dati mancanti, completa pianificazione e disponibilità.',
  'scheduler.confidence_level.alta': 'alta',
  'scheduler.confidence_level.media': 'media',
  'scheduler.confidence_level.bassa': 'bassa',
  'scheduler.banner.over_capacity': '{{count}} {{days}} in over-capacity rispetto alla disponibilità pubblicata. Apri il calendario per ridistribuire o aggiornare la capacità.',
  'scheduler.banner.closed_with_load': 'Hai lavoro pianificato in {{count}} {{days}} dichiarate chiuse. Riapri la fascia o sposta gli interventi.',
  'scheduler.banner.same_day_cluster': '{{count}} {{days}} con cluster di turnover same-day: pianifica con margini ampi tra checkout e check-in.',
  'scheduler.banner.near_capacity': '{{count}} {{days}} vicini alla saturazione: valuta se accettare altro carico.',
  'scheduler.banner.day_one': 'giorno',
  'scheduler.banner.day_many': 'giorni',
  'scheduler.banner.date_one': 'giornata',
  'scheduler.banner.date_many': 'giornate',
};
export default it;
